/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum LegalSkill {
  CopyrightAdviceAndCounsel = "CopyrightAdviceAndCounsel",
  CopyrightEnforcement = "CopyrightEnforcement",
  CopyrightFilingsRegistrationAndAssignment = "CopyrightFilingsRegistrationAndAssignment",
  CopyrightFreedomToOperate = "CopyrightFreedomToOperate",
  CopyrightInboundLicencing = "CopyrightInboundLicencing",
  CopyrightOutboundLicensing = "CopyrightOutboundLicensing",
  TrademarkAdviceAndCounsel = "TrademarkAdviceAndCounsel",
  TrademarkApplicationsRegistrationsAndAssignments = "TrademarkApplicationsRegistrationsAndAssignments",
  TrademarkEnforcementCeaseAndDesistLettersAndInfringementMatters = "TrademarkEnforcementCeaseAndDesistLettersAndInfringementMatters",
  TrademarkEnforcementOppositionsInvalidationsAndCancellations = "TrademarkEnforcementOppositionsInvalidationsAndCancellations",
  TrademarkSearchAndClearance = "TrademarkSearchAndClearance",
  TrademarkFreedomToOperate = "TrademarkFreedomToOperate",
  TrademarkInboundLicencing = "TrademarkInboundLicencing",
  TrademarkOutboundLicensing = "TrademarkOutboundLicensing",
  AIMachineLearningDataLearningAdviceAndCounsel_PatentActivities = "AIMachineLearningDataLearningAdviceAndCounsel_PatentActivities",
  DueDiligenceAssessments = "DueDiligenceAssessments",
  FreedomToOperate_PatentActivities = "FreedomToOperate_PatentActivities",
  OutsideCounselManagement_PatentActivities = "OutsideCounselManagement_PatentActivities",
  InternationalPatentProsecution = "InternationalPatentProsecution",
  InfringementMatters = "InfringementMatters",
  NDAsMTAsJDAsEtc = "NDAsMTAsJDAsEtc",
  PatentInboundLicensing = "PatentInboundLicensing",
  PatentOutboundLicensing = "PatentOutboundLicensing",
  PatentPortfolioManagement = "PatentPortfolioManagement",
  PatentPreparation = "PatentPreparation",
  PatentSearching = "PatentSearching",
  PatentValuation = "PatentValuation",
  PatentAdviceAndCounsel = "PatentAdviceAndCounsel",
  TradeSecretAdviceAndCounsel_PatentActivities = "TradeSecretAdviceAndCounsel_PatentActivities",
  Aerospace = "Aerospace",
  Biology = "Biology",
  Biotech = "Biotech",
  Chemical = "Chemical",
  ComputerHardware = "ComputerHardware",
  Mechanical = "Mechanical",
  Pharmaceuticals = "Pharmaceuticals",
  Physics = "Physics",
  Software_PatentType = "Software_PatentType",
  Appeals_LitigationActivities_IntellectualPropertyLitigation = "Appeals_LitigationActivities_IntellectualPropertyLitigation",
  DiscoveryDocumentReviewAndManagement_LitigationActivities_IntellectualPropertyLitigation = "DiscoveryDocumentReviewAndManagement_LitigationActivities_IntellectualPropertyLitigation",
  LitigationAdviceAndCounsel_LitigationActivities_IntellectualPropertyLitigation = "LitigationAdviceAndCounsel_LitigationActivities_IntellectualPropertyLitigation",
  NegotiationSettlementMediationAndAlternativeDisputeResolution_LitigationActivities_IntellectualPropertyLitigation = "NegotiationSettlementMediationAndAlternativeDisputeResolution_LitigationActivities_IntellectualPropertyLitigation",
  OutsideCounselManagement_LitigationActivities_IntellectualPropertyLitigation = "OutsideCounselManagement_LitigationActivities_IntellectualPropertyLitigation",
  PleadingsMotionsAndDepositions_LitigationActivities_IntellectualPropertyLitigation = "PleadingsMotionsAndDepositions_LitigationActivities_IntellectualPropertyLitigation",
  PreSuitInvestigationAndPreparation_LitigationActivities_IntellectualPropertyLitigation = "PreSuitInvestigationAndPreparation_LitigationActivities_IntellectualPropertyLitigation",
  TrialsAndArbitrations_LitigationActivities_IntellectualPropertyLitigation = "TrialsAndArbitrations_LitigationActivities_IntellectualPropertyLitigation",
  US401K = "US401K",
  USEmployeeRetirementIncomeSecuritiesActERISA = "USEmployeeRetirementIncomeSecuritiesActERISA",
  USEmployeeStockOwnershipPlanESOPAndProfitSharing = "USEmployeeStockOwnershipPlanESOPAndProfitSharing",
  ExecutiveCompensationAndBenefits = "ExecutiveCompensationAndBenefits",
  PhantomStockSpecializedCompensation = "PhantomStockSpecializedCompensation",
  HealthPlans = "HealthPlans",
  PensionPlans = "PensionPlans",
  CafeteriaPlans = "CafeteriaPlans",
  AsianBenefitsExpertise = "AsianBenefitsExpertise",
  AustralianBenefitsExpertise = "AustralianBenefitsExpertise",
  CanadianBenefitsExpertise = "CanadianBenefitsExpertise",
  EuropeanBenefitsExpertise = "EuropeanBenefitsExpertise",
  UKBenefitsExpertise = "UKBenefitsExpertise",
  HIPAACompliance_EmployeeBenefitsERISACompensationBenefitsAndPensions = "HIPAACompliance_EmployeeBenefitsERISACompensationBenefitsAndPensions",
  ACACompliance = "ACACompliance",
  ManagingWorkplaceInvestigations = "ManagingWorkplaceInvestigations",
  ConductingWorkplaceInvestigations = "ConductingWorkplaceInvestigations",
  PolicyDevelopmentAndTraining = "PolicyDevelopmentAndTraining",
  AdministrativeChargesAndProceedingsEEOCNLRBOSHA = "AdministrativeChargesAndProceedingsEEOCNLRBOSHA",
  USCaliforniaLAndEExpertise = "USCaliforniaLAndEExpertise",
  ContingentWorkforceExperience = "ContingentWorkforceExperience",
  EmploymentAgreementsRestrictiveCovenantsSeveranceAgreementsEtc = "EmploymentAgreementsRestrictiveCovenantsSeveranceAgreementsEtc",
  EmploymentLitigation = "EmploymentLitigation",
  EmploymentRegulatoryCompliance = "EmploymentRegulatoryCompliance",
  ExternalAuditsDOLEEOCOSHA = "ExternalAuditsDOLEEOCOSHA",
  Immigration = "Immigration",
  UKEmploymentExpertise = "UKEmploymentExpertise",
  EuropeanEmploymentExpertise = "EuropeanEmploymentExpertise",
  AsianEmploymentExpertise = "AsianEmploymentExpertise",
  AustralianEmploymentExpertise = "AustralianEmploymentExpertise",
  CanadianEmploymentExpertise = "CanadianEmploymentExpertise",
  LeaveAccommodationsAndUSFMLA = "LeaveAccommodationsAndUSFMLA",
  PoliciesPlaybooksHandbooksAndTraining = "PoliciesPlaybooksHandbooksAndTraining",
  ReductionsInForceRIFsAndReorgs = "ReductionsInForceRIFsAndReorgs",
  WageAndHourLaws = "WageAndHourLaws",
  PostDivestitureHRCounseling = "PostDivestitureHRCounseling",
  TitleVIIExpertise = "TitleVIIExpertise",
  PayEquityAndTransparency = "PayEquityAndTransparency",
  EmployeePrivacyAndTechnologyCounseling = "EmployeePrivacyAndTechnologyCounseling",
  LaborAdviceAndCounsel = "LaborAdviceAndCounsel",
  LaborInvestigations = "LaborInvestigations",
  LaborNegotiationAndCollectiveBargaining = "LaborNegotiationAndCollectiveBargaining",
  LaborPoliciesAndProcedures = "LaborPoliciesAndProcedures",
  LaborTraining = "LaborTraining",
  AdministrationOrders = "AdministrationOrders",
  BankruptcyAndInsolvencyLitigation = "BankruptcyAndInsolvencyLitigation",
  CompanyVoluntaryArrangementsCVAs = "CompanyVoluntaryArrangementsCVAs",
  DebtorCreditorDisputes = "DebtorCreditorDisputes",
  ProvisionalLiquidation = "ProvisionalLiquidation",
  Receiverships = "Receiverships",
  SchemesOfArrangement = "SchemesOfArrangement",
  SideLetters = "SideLetters",
  Administration = "Administration",
  Chapter11ReorganizationAndStrategicCorporateRestructuring = "Chapter11ReorganizationAndStrategicCorporateRestructuring",
  Chapter13 = "Chapter13",
  Chapter7 = "Chapter7",
  CompanyVoluntaryArrangementCVA = "CompanyVoluntaryArrangementCVA",
  IndividualVoluntaryArrangementIVA = "IndividualVoluntaryArrangementIVA",
  LiquidationCompulsoryAndVoluntary = "LiquidationCompulsoryAndVoluntary",
  Receivership = "Receivership",
  DueDiligence = "DueDiligence",
  LegalOpinionsAndComfortLetters = "LegalOpinionsAndComfortLetters",
  OfferingDocumentDrafting = "OfferingDocumentDrafting",
  OperativeDocumentDraftingMBSABS = "OperativeDocumentDraftingMBSABS",
  ProgramTrading = "ProgramTrading",
  SubscriptionAgreements = "SubscriptionAgreements",
  TradingDeskAdviceAndCounsel = "TradingDeskAdviceAndCounsel",
  TransactionManagement = "TransactionManagement",
  TransactionDocumentationNegotiationABSMBS = "TransactionDocumentationNegotiationABSMBS",
  TransactionDocumentationDraftingABSMBS = "TransactionDocumentationDraftingABSMBS",
  CommitmentLetters = "CommitmentLetters",
  CreditAgreements = "CreditAgreements",
  HedgingAgreements = "HedgingAgreements",
  IntercreditorAgreements = "IntercreditorAgreements",
  TermSheets = "TermSheets",
  MezzanineFinance = "MezzanineFinance",
  SeniorSecuredLoans = "SeniorSecuredLoans",
  PrivateIssuances = "PrivateIssuances",
  PublicIssuances = "PublicIssuances",
  BondsHighYield = "BondsHighYield",
  BondsInvestmentGrade = "BondsInvestmentGrade",
  MortgageOrOtherAssetBackedSecuritiesMBSABS = "MortgageOrOtherAssetBackedSecuritiesMBSABS",
  EuropeanRegulatoryAdvisory = "EuropeanRegulatoryAdvisory",
  UKRegulatoryAdvisory = "UKRegulatoryAdvisory",
  AsianRegulatoryAdvisory = "AsianRegulatoryAdvisory",
  AustralianRegulatoryAdvisory = "AustralianRegulatoryAdvisory",
  CanadianRegulatoryAdvisory = "CanadianRegulatoryAdvisory",
  USExchangeActOf1934Compliance = "USExchangeActOf1934Compliance",
  USSecuritiesActOf1933Compliance = "USSecuritiesActOf1933Compliance",
  DueDiligence_Activities_EquityCapitalMarkets = "DueDiligence_Activities_EquityCapitalMarkets",
  IssuanceOfEquitySecurities = "IssuanceOfEquitySecurities",
  IssuanceProgramDevelopment = "IssuanceProgramDevelopment",
  PrivatePlacementMemorandum = "PrivatePlacementMemorandum",
  StructuringAndDraftingOfEquityOfferings = "StructuringAndDraftingOfEquityOfferings",
  InitialPublicOfferingsIPOs = "InitialPublicOfferingsIPOs",
  SecondaryOfferings = "SecondaryOfferings",
  BlockTrades = "BlockTrades",
  CashEquitiesAndStocks = "CashEquitiesAndStocks",
  ConvertibleStock = "ConvertibleStock",
  EuropeanRegulatoryAdvisory_RegulatoryExpertise = "EuropeanRegulatoryAdvisory_RegulatoryExpertise",
  CanadianRegulatoryAdvisory_RegulatoryExpertise = "CanadianRegulatoryAdvisory_RegulatoryExpertise",
  UKRegulatoryAdvisory_RegulatoryExpertise = "UKRegulatoryAdvisory_RegulatoryExpertise",
  AsianRegulatoryAdvisory_RegulatoryExpertise = "AsianRegulatoryAdvisory_RegulatoryExpertise",
  AustralianRegulatoryAdvisory_RegulatoryExpertise = "AustralianRegulatoryAdvisory_RegulatoryExpertise",
  TheInvestmentCompanyActof1940Compliance = "TheInvestmentCompanyActof1940Compliance",
  USExchangeActOf1934Compliance_RegulatoryExpertise = "USExchangeActOf1934Compliance_RegulatoryExpertise",
  USSecuritiesActOf1933Compliance_RegulatoryExpertise = "USSecuritiesActOf1933Compliance_RegulatoryExpertise",
  AdTechTransactions = "AdTechTransactions",
  BehavioralAdvertising = "BehavioralAdvertising",
  ConsumerDataRegulatoryCompliance = "ConsumerDataRegulatoryCompliance",
  AdvertisingComplianceReview = "AdvertisingComplianceReview",
  DataMonetization = "DataMonetization",
  DataPartnerships = "DataPartnerships",
  EUDigitalServicesAct = "EUDigitalServicesAct",
  AdTechPrivacy = "AdTechPrivacy",
  MobilePlatforms = "MobilePlatforms",
  DirectProcurementAgreements = "DirectProcurementAgreements",
  EBAOutsourcing = "EBAOutsourcing",
  IndirectProcurementAgreements = "IndirectProcurementAgreements",
  InfrastructurePlatformLicensingAgreements = "InfrastructurePlatformLicensingAgreements",
  ITProcurementAgreements = "ITProcurementAgreements",
  PublicProcurement = "PublicProcurement",
  VendorAndSupplierAgreements = "VendorAndSupplierAgreements",
  ThirdPartyRiskAssessmentMitigation = "ThirdPartyRiskAssessmentMitigation",
  SourcingPartnerAnalysis = "SourcingPartnerAnalysis",
  OutsourcedRiskScreeningTool = "OutsourcedRiskScreeningTool",
  SupplierSustainabilityScore = "SupplierSustainabilityScore",
  AdTechProductLaunch = "AdTechProductLaunch",
  AIAndMachineLearningMLProducts = "AIAndMachineLearningMLProducts",
  AIRegulatoryCompliance = "AIRegulatoryCompliance",
  AISocialResponsibility = "AISocialResponsibility",
  B2BProducts = "B2BProducts",
  B2CProducts = "B2CProducts",
  ConsumerProtection = "ConsumerProtection",
  ContentModeration = "ContentModeration",
  DigitalAccessibilityCounselWCAG = "DigitalAccessibilityCounselWCAG",
  DigitalMarketingAct = "DigitalMarketingAct",
  DigitalServicesAct = "DigitalServicesAct",
  EUDataAct = "EUDataAct",
  Hardware = "Hardware",
  MarketingCompliance = "MarketingCompliance",
  OnlineSafetyAct = "OnlineSafetyAct",
  PaymentAndFintechProducts = "PaymentAndFintechProducts",
  Payments_Expertise_ProductCounsel = "Payments_Expertise_ProductCounsel",
  Section230CDA = "Section230CDA",
  SocialMediaOrPlatformProductExperience = "SocialMediaOrPlatformProductExperience",
  Software = "Software",
  TrustAndSafety = "TrustAndSafety",
  UXUIReview = "UXUIReview",
  VRARDevice = "VRARDevice",
  SupplierDistributorAndManufacturerAgreements = "SupplierDistributorAndManufacturerAgreements",
  VendorAndServiceAgreements_AgreementTypes = "VendorAndServiceAgreements_AgreementTypes",
  ElectricVehicles = "ElectricVehicles",
  Maritime = "Maritime",
  TransportationRegulatoryCompliance = "TransportationRegulatoryCompliance",
  TruckingRailAndAutomotive = "TruckingRailAndAutomotive",
  LifecycleRiskManagement = "LifecycleRiskManagement",
  OnboardingVendorDueDiligence = "OnboardingVendorDueDiligence",
  ThirdPartyRiskManagementSoftwareSelectionImplementation = "ThirdPartyRiskManagementSoftwareSelectionImplementation",
  ThirdPartySustainabilityScoreAssessmentDevelopment = "ThirdPartySustainabilityScoreAssessmentDevelopment",
  ThirdPartyRiskEvaluation = "ThirdPartyRiskEvaluation",
  BrandProtection = "BrandProtection",
  CampaignCreationAdvisory = "CampaignCreationAdvisory",
  ProductLaunchAdvisory = "ProductLaunchAdvisory",
  AdvertisingComplianceReview_Activities = "AdvertisingComplianceReview_Activities",
  MarketingPrivacyCounsel = "MarketingPrivacyCounsel",
  InfluencerAgreements = "InfluencerAgreements",
  LicensingAgreements = "LicensingAgreements",
  MarketingAndSponsorshipAgreements = "MarketingAndSponsorshipAgreements",
  SweepstakesAndContestsRulesAndAgreements = "SweepstakesAndContestsRulesAndAgreements",
  AustralianRegulatoryAdvisory_RegulatoryExpertise_AdvertisingMarketingAndPromotionalReview = "AustralianRegulatoryAdvisory_RegulatoryExpertise_AdvertisingMarketingAndPromotionalReview",
  CanadianRegulatoryAdvisory_RegulatoryExpertise_AdvertisingMarketingAndPromotionalReview = "CanadianRegulatoryAdvisory_RegulatoryExpertise_AdvertisingMarketingAndPromotionalReview",
  EuropeanRegulatoryAdvisory_RegulatoryExpertise_AdvertisingMarketingAndPromotionalReview = "EuropeanRegulatoryAdvisory_RegulatoryExpertise_AdvertisingMarketingAndPromotionalReview",
  UKRegulatoryAdvisory_RegulatoryExpertise_AdvertisingMarketingAndPromotionalReview = "UKRegulatoryAdvisory_RegulatoryExpertise_AdvertisingMarketingAndPromotionalReview",
  AsianRegulatoryAdvisory_RegulatoryExpertise_AdvertisingMarketingAndPromotionalReview = "AsianRegulatoryAdvisory_RegulatoryExpertise_AdvertisingMarketingAndPromotionalReview",
  USTelephoneConsumerProtectionActTCPACompliance = "USTelephoneConsumerProtectionActTCPACompliance",
  USFDAAdvisory_RegulatoryExpertise = "USFDAAdvisory_RegulatoryExpertise",
  USTelemarketingSalesRuleTSRCompliance = "USTelemarketingSalesRuleTSRCompliance",
  USFTCAdvisory = "USFTCAdvisory",
  CloudAndSaaSAgreements = "CloudAndSaaSAgreements",
  EndUserLicenseAgreementsEULA = "EndUserLicenseAgreementsEULA",
  InboundLicensing = "InboundLicensing",
  OutboundLicensing = "OutboundLicensing",
  SoftwareAgreements = "SoftwareAgreements",
  StrategicPartnerships = "StrategicPartnerships",
  ITVendorContracts = "ITVendorContracts",
  PaaSIaaSAgreements = "PaaSIaaSAgreements",
  TemplateAndPlaybookCreation_Expertise_CloudSaaSSoftwareLicensing = "TemplateAndPlaybookCreation_Expertise_CloudSaaSSoftwareLicensing",
  ArtificialIntelligenceAndMachineLearningAIAndML = "ArtificialIntelligenceAndMachineLearningAIAndML",
  B2B = "B2B",
  B2C = "B2C",
  EmergingTechnology = "EmergingTechnology",
  BlockchainAndCryptocurrency = "BlockchainAndCryptocurrency",
  Electronics = "Electronics",
  GeneralTech = "GeneralTech",
  Hardware_IndustryExperience = "Hardware_IndustryExperience",
  Semiconductors = "Semiconductors",
  SaaSAndSoftware = "SaaSAndSoftware",
  ContractDrafting = "ContractDrafting",
  ContractManagementSystemCMSSelectionAndLaunch = "ContractManagementSystemCMSSelectionAndLaunch",
  ContractNegotiation = "ContractNegotiation",
  ContractTemplatesAndPlaybooks = "ContractTemplatesAndPlaybooks",
  BreachOfContractDisputes = "BreachOfContractDisputes",
  TrainingSalesonContracts = "TrainingSalesonContracts",
  DistributionAgreements_ContractTypes = "DistributionAgreements_ContractTypes",
  EntertainmentContractsContentProductionCollaboration = "EntertainmentContractsContentProductionCollaboration",
  MasterServiceAgreementsMSAs = "MasterServiceAgreementsMSAs",
  NonDisclosureAgreementsNDAs = "NonDisclosureAgreementsNDAs",
  ProductPurchaseAgreementsGoods = "ProductPurchaseAgreementsGoods",
  ProfessionalServiceAgreements = "ProfessionalServiceAgreements",
  SalesAndVendorAgreementsServices = "SalesAndVendorAgreementsServices",
  StatementsOfWorkSOWs = "StatementsOfWorkSOWs",
  ContractManagementAndAdministration = "ContractManagementAndAdministration",
  Environmental = "Environmental",
  NuclearSafetyAndLiability = "NuclearSafetyAndLiability",
  NuclearTechnology = "NuclearTechnology",
  NuclearTrade = "NuclearTrade",
  Permitting = "Permitting",
  PolicyCreationAndAdvocacy = "PolicyCreationAndAdvocacy",
  RegulatoryAdvisory_AreaOfExpertise = "RegulatoryAdvisory_AreaOfExpertise",
  WasteDisposal = "WasteDisposal",
  AustralianRegulatoryAdvisory_RegulatoryExpertise_EnergyOilAndGas = "AustralianRegulatoryAdvisory_RegulatoryExpertise_EnergyOilAndGas",
  AsianRegulatoryAdvisory_RegulatoryExpertise_EnergyOilAndGas = "AsianRegulatoryAdvisory_RegulatoryExpertise_EnergyOilAndGas",
  CanadianRegulatoryAdvisory_RegulatoryExpertise_EnergyOilAndGas = "CanadianRegulatoryAdvisory_RegulatoryExpertise_EnergyOilAndGas",
  EuropeanRegulatoryAdvisory_RegulatoryExpertise_EnergyOilAndGas = "EuropeanRegulatoryAdvisory_RegulatoryExpertise_EnergyOilAndGas",
  UKRegulatoryAdvisory_RegulatoryExpertise_EnergyOilAndGas = "UKRegulatoryAdvisory_RegulatoryExpertise_EnergyOilAndGas",
  USRegulatoryAdvisory = "USRegulatoryAdvisory",
  NorthAmericanElectricReliabilityCorporation_RegulatoryExpertise_EnergyOilAndGas = "NorthAmericanElectricReliabilityCorporation_RegulatoryExpertise_EnergyOilAndGas",
  Financing = "Financing",
  OilFieldServices = "OilFieldServices",
  ProcessingAndRefining = "ProcessingAndRefining",
  SalesAgreements = "SalesAgreements",
  Regulatory_Activities_EnergyOilAndGas = "Regulatory_Activities_EnergyOilAndGas",
  Offshore_Activities_EnergyOilAndGas = "Offshore_Activities_EnergyOilAndGas",
  Onshore_Activities_EnergyOilAndGas = "Onshore_Activities_EnergyOilAndGas",
  InflationReductionAct = "InflationReductionAct",
  InternationalExperience_Activities_EnergyOilAndGas = "InternationalExperience_Activities_EnergyOilAndGas",
  Pipeline_Activities_EnergyOilAndGas = "Pipeline_Activities_EnergyOilAndGas",
  ConcessionAgreementsFarmOutAndFarmIn = "ConcessionAgreementsFarmOutAndFarmIn",
  NAESBs_Activities_EnergyOilAndGas = "NAESBs_Activities_EnergyOilAndGas",
  ISDAs_Activities_EnergyOilAndGas = "ISDAs_Activities_EnergyOilAndGas",
  EngineeringProcurementAndConstructionEPC_Activities_EnergyOilAndGas = "EngineeringProcurementAndConstructionEPC_Activities_EnergyOilAndGas",
  GulfOfMexicoExperience = "GulfOfMexicoExperience",
  Chemicals_Activities_EnergyOilAndGas = "Chemicals_Activities_EnergyOilAndGas",
  Railroad_Activities_EnergyOilAndGas = "Railroad_Activities_EnergyOilAndGas",
  CommercialContractsOther_Activities_EnergyOilAndGas = "CommercialContractsOther_Activities_EnergyOilAndGas",
  RealEstate_Activities_EnergyOilAndGas = "RealEstate_Activities_EnergyOilAndGas",
  TransportationAgreements_Activities_EnergyOilAndGas = "TransportationAgreements_Activities_EnergyOilAndGas",
  SupplyChain_Activities_EnergyOilAndGas = "SupplyChain_Activities_EnergyOilAndGas",
  CarbonCaptureAndStorageCCS = "CarbonCaptureAndStorageCCS",
  NaturalGas = "NaturalGas",
  LiquefiedNaturalGasLNG = "LiquefiedNaturalGasLNG",
  Oil = "Oil",
  Hydrocarbon = "Hydrocarbon",
  LandfillGas = "LandfillGas",
  Downstream = "Downstream",
  Midstream = "Midstream",
  Upstream = "Upstream",
  CommercialContractsOtherProcurementAgreementsMSAsEtc = "CommercialContractsOtherProcurementAgreementsMSAsEtc",
  CommercialContractsPowerPurchaseAgreementsPPAs = "CommercialContractsPowerPurchaseAgreementsPPAs",
  ConcessionAgreementsFarmoutAndFarmin = "ConcessionAgreementsFarmoutAndFarmin",
  EngineeringProcurementAndConstructionEPC = "EngineeringProcurementAndConstructionEPC",
  JointVenturesAndCorporateStructure = "JointVenturesAndCorporateStructure",
  ProjectFinancing = "ProjectFinancing",
  RealEstate = "RealEstate",
  CommercialContractsFPPA = "CommercialContractsFPPA",
  CommercialContractsVPPA = "CommercialContractsVPPA",
  CommercialContractsInterconnectionAgreements = "CommercialContractsInterconnectionAgreements",
  NAESBs_Activities_EnergyRenewable = "NAESBs_Activities_EnergyRenewable",
  ISDAs_Activities_EnergyRenewable = "ISDAs_Activities_EnergyRenewable",
  EnergyTrading = "EnergyTrading",
  BatteryEnergyStorageSystemBESS = "BatteryEnergyStorageSystemBESS",
  RenewableEnergyCertificateREC = "RenewableEnergyCertificateREC",
  SupplyChain_Activities_EnergyRenewable = "SupplyChain_Activities_EnergyRenewable",
  BuildTransferAgreementsBTAs = "BuildTransferAgreementsBTAs",
  BatteryStorage = "BatteryStorage",
  BiomassAndWaste = "BiomassAndWaste",
  Hydrogen = "Hydrogen",
  OffshoreWind = "OffshoreWind",
  OnshoreWind = "OnshoreWind",
  RetailEnergy = "RetailEnergy",
  Solar = "Solar",
  Utility_EnergyType_EnergyRenewable = "Utility_EnergyType_EnergyRenewable",
  RenewableNaturalGasRNG = "RenewableNaturalGasRNG",
  USERCOTAndPUCAndotherISOs = "USERCOTAndPUCAndotherISOs",
  USFederalEnergyRegulatoryCommissionFERC_RegulatoryExpertise_EnergyRenewable = "USFederalEnergyRegulatoryCommissionFERC_RegulatoryExpertise_EnergyRenewable",
  NorthAmericanElectricReliabilityCorporation_RegulatoryExpertise_EnergyRenewable = "NorthAmericanElectricReliabilityCorporation_RegulatoryExpertise_EnergyRenewable",
  USPipelineAndHazardousMaterialsSafetyAdministrationPHMSA = "USPipelineAndHazardousMaterialsSafetyAdministrationPHMSA",
  UtilityLocalRegulatory = "UtilityLocalRegulatory",
  UtilityStateRegulatory = "UtilityStateRegulatory",
  USCaliforniaPublicUtilitiesCommissionCPUC = "USCaliforniaPublicUtilitiesCommissionCPUC",
  USCommodityFuturesTradingCommissionCFTC = "USCommodityFuturesTradingCommissionCFTC",
  CommercialAndIndustrialCAndI = "CommercialAndIndustrialCAndI",
  DistributedGenerationCommunityAndRooftopSolar = "DistributedGenerationCommunityAndRooftopSolar",
  DistributedGenerationElectricVehicleChargers = "DistributedGenerationElectricVehicleChargers",
  UtilityScale = "UtilityScale",
  PowerPurchaseAgreementsPPAs = "PowerPurchaseAgreementsPPAs",
  UtilityRateCasesAndTariffFilings = "UtilityRateCasesAndTariffFilings",
  GridInterconnectionAndTransmissionAgreements = "GridInterconnectionAndTransmissionAgreements",
  EnergyTradingAndCommodityTransactions = "EnergyTradingAndCommodityTransactions",
  LandRightsAndEasementAcquisition = "LandRightsAndEasementAcquisition",
  EnergyStorageAndBatteryProjects = "EnergyStorageAndBatteryProjects",
  GridModernizationAndSmartGridDevelopment = "GridModernizationAndSmartGridDevelopment",
  ElectricVehicleInfrastructureDevelopment = "ElectricVehicleInfrastructureDevelopment",
  JointOperatingAgreements = "JointOperatingAgreements",
  ElectronicServiceAgreements = "ElectronicServiceAgreements",
  FederalEnergyRegulatoryCommissionFERCCompliance = "FederalEnergyRegulatoryCommissionFERCCompliance",
  StatePublicUtilityCommissionProceedings = "StatePublicUtilityCommissionProceedings",
  NorthAmericanElectricReliabilityCorporationNERCStandards = "NorthAmericanElectricReliabilityCorporationNERCStandards",
  CaliforniaPublicUtilitiesCommission = "CaliforniaPublicUtilitiesCommission",
  ContractDraftingNegotiationAndReview = "ContractDraftingNegotiationAndReview",
  ContractLifecycleManagement = "ContractLifecycleManagement",
  PoliciesAndProceduresDevelopment = "PoliciesAndProceduresDevelopment",
  BidStrategyAdviceAndCounsel = "BidStrategyAdviceAndCounsel",
  RFPReviewAndRiskAssessments = "RFPReviewAndRiskAssessments",
  PostAwardContractAdministration = "PostAwardContractAdministration",
  ProcurementAndBidManagement = "ProcurementAndBidManagement",
  NationalAndFederalGovernment = "NationalAndFederalGovernment",
  LocalGovernment = "LocalGovernment",
  StateAndProvincialGovernment = "StateAndProvincialGovernment",
  FederalAcquisitionRegulationFARCompliance = "FederalAcquisitionRegulationFARCompliance",
  DefenseFederalAcquisitionRegulationSupplement = "DefenseFederalAcquisitionRegulationSupplement",
  SmallBusinessAdministrationSBARegulations = "SmallBusinessAdministrationSBARegulations",
  CostAccountingStandardsCASCompliance = "CostAccountingStandardsCASCompliance",
  TruthInNegotiationsActTINE = "TruthInNegotiationsActTINE",
  BuyAmericanAct = "BuyAmericanAct",
  ServiceContractLaborStandardsSCLS = "ServiceContractLaborStandardsSCLS",
  FederalInformationSecurityManagementActFISMA = "FederalInformationSecurityManagementActFISMA",
  ExportAdministrationRegulationsEARITAR = "ExportAdministrationRegulationsEARITAR",
  GovernmentEthicsAndOrganizationalConflictsOfInterest = "GovernmentEthicsAndOrganizationalConflictsOfInterest",
  ContractDisputesActAndClaimsProcedures = "ContractDisputesActAndClaimsProcedures",
  FreedomOfInformationActFOIA = "FreedomOfInformationActFOIA",
  BoardMeetingMinutesAndAdministration = "BoardMeetingMinutesAndAdministration",
  BylawsAndCorporateGovernanceDocuments = "BylawsAndCorporateGovernanceDocuments",
  CompanyFilingCompliance = "CompanyFilingCompliance",
  CorporateDiligenceAndReporting = "CorporateDiligenceAndReporting",
  ISOComplianceAndCorporateStandards = "ISOComplianceAndCorporateStandards",
  SubsidiaryManagement = "SubsidiaryManagement",
  QuarterlyAndAnnualReports = "QuarterlyAndAnnualReports",
  EntityManagementAndCompliance = "EntityManagementAndCompliance",
  USReportingForms10K10QS1S4And8K = "USReportingForms10K10QS1S4And8K",
  UKPeriodicReportingUKCompaniesActAndUKListingRules = "UKPeriodicReportingUKCompaniesActAndUKListingRules",
  CanadianDisclosureRequirements = "CanadianDisclosureRequirements",
  AsianStockExchangeReporting = "AsianStockExchangeReporting",
  EuropeanCompliance = "EuropeanCompliance",
  AustralianCompliance = "AustralianCompliance",
  ProxyStatementsAndReports = "ProxyStatementsAndReports",
  RegulatoryAndStockExchangeCompliance = "RegulatoryAndStockExchangeCompliance",
  AIPrograms = "AIPrograms",
  DataMappingAndInventory = "DataMappingAndInventory",
  DataPrivacyImpactAssessmentDPIAPIA = "DataPrivacyImpactAssessmentDPIAPIA",
  DataSubjectAccessRequestsDSARs = "DataSubjectAccessRequestsDSARs",
  EmployeeTraining = "EmployeeTraining",
  GeneralPrivacyAdviceAndCounsel = "GeneralPrivacyAdviceAndCounsel",
  PrivacyAgreementTemplatePreparation = "PrivacyAgreementTemplatePreparation",
  PrivacyAndCybersecurityIncidentResponse = "PrivacyAndCybersecurityIncidentResponse",
  PrivacyByDesignPrivacyByDefault = "PrivacyByDesignPrivacyByDefault",
  PrivacyGapAssessment = "PrivacyGapAssessment",
  PrivacyPlaybookDevelopment = "PrivacyPlaybookDevelopment",
  PrivacyProgramDevelopment = "PrivacyProgramDevelopment",
  WebsitePrivacyPoliciesAndTermsOfUse = "WebsitePrivacyPoliciesAndTermsOfUse",
  DataProcessingAgreementDPAs = "DataProcessingAgreementDPAs",
  DataLicensingAndAcquisitionAgreements = "DataLicensingAndAcquisitionAgreements",
  PrivacyClauseDraftingAndNegotiation = "PrivacyClauseDraftingAndNegotiation",
  StandardContractualClausesSCCs = "StandardContractualClausesSCCs",
  AILawsGlobal = "AILawsGlobal",
  AsiaPrivacyRegulationsPIPLAndOtherNonEnglish = "AsiaPrivacyRegulationsPIPLAndOtherNonEnglish",
  AustralianPrivacyLaws = "AustralianPrivacyLaws",
  BrazilLeiGeralDeProtecaoDeDadosPessoaisLGPD = "BrazilLeiGeralDeProtecaoDeDadosPessoaisLGPD",
  CanadaPIPEDA = "CanadaPIPEDA",
  ChinaPIPLAndDataLocalization = "ChinaPIPLAndDataLocalization",
  EUAIAct = "EUAIAct",
  EUEPrivacyDirective = "EUEPrivacyDirective",
  EUGeneralDataProtectionRegulationGDPR = "EUGeneralDataProtectionRegulationGDPR",
  EuropeanPrivacyLaws = "EuropeanPrivacyLaws",
  HongKongPrivacyLaw = "HongKongPrivacyLaw",
  IndiaPrivacyRegulations = "IndiaPrivacyRegulations",
  SingaporeanPrivacyLawsPDPA = "SingaporeanPrivacyLawsPDPA",
  UKPrivacyLaws = "UKPrivacyLaws",
  EUUSDataPrivacyFrameworkDPF = "EUUSDataPrivacyFrameworkDPF",
  USChildrensPrivacyRegulationsCOPPAAndStateLaws = "USChildrensPrivacyRegulationsCOPPAAndStateLaws",
  USFinancialPrivacyGrammLeachBlileyActGLBAAndSECPrivacyRegulations = "USFinancialPrivacyGrammLeachBlileyActGLBAAndSECPrivacyRegulations",
  USHealthInsurancePortabilityAndAccountabilityActHIPAAAndStateHealthPrivacyLaws = "USHealthInsurancePortabilityAndAccountabilityActHIPAAAndStateHealthPrivacyLaws",
  USWebContentAccessibilityGuidelinesWCAG = "USWebContentAccessibilityGuidelinesWCAG",
  USStatePrivacyLawsIncludingCCPACPRA = "USStatePrivacyLawsIncludingCCPACPRA",
  USBiometricsLaws = "USBiometricsLaws",
  MiddleEastPrivacyLaws = "MiddleEastPrivacyLaws",
  AgreementDraftingAndNegotiation = "AgreementDraftingAndNegotiation",
  IncidentResponsePoliciesAndProcedures = "IncidentResponsePoliciesAndProcedures",
  IncidentResponseSupportIncludingNotifications = "IncidentResponseSupportIncludingNotifications",
  SecuritybyDesign = "SecuritybyDesign",
  AssetBasedLending = "AssetBasedLending",
  AviationFinance = "AviationFinance",
  EquipmentFinance = "EquipmentFinance",
  MarineAndMaritimeFinance = "MarineAndMaritimeFinance",
  SupplyChainFinance = "SupplyChainFinance",
  TransportationFinance = "TransportationFinance",
  VendorFinance = "VendorFinance",
  B2BPaymentProducts = "B2BPaymentProducts",
  CardsAndPrepaidCards = "CardsAndPrepaidCards",
  DigitalAndMobileBanking = "DigitalAndMobileBanking",
  ElectronicFundsTransfersEFTs = "ElectronicFundsTransfersEFTs",
  MobileWallets = "MobileWallets",
  Peer2PeerPaymentProductsP2P = "Peer2PeerPaymentProductsP2P",
  CentralBankDigitalCurrenciesCBDCs = "CentralBankDigitalCurrenciesCBDCs",
  Cryptocurrency = "Cryptocurrency",
  InitialCoinOfferingsICOs = "InitialCoinOfferingsICOs",
  TradingPlatforms = "TradingPlatforms",
  ConsumerBankingProducts = "ConsumerBankingProducts",
  BuyNowPayLAterBNPLServices = "BuyNowPayLAterBNPLServices",
  CrossBorderPaymentSolutions = "CrossBorderPaymentSolutions",
  EUPaymentServicesDirectivePSD = "EUPaymentServicesDirectivePSD",
  USElectronicFundsTransferActEFTA = "USElectronicFundsTransferActEFTA",
  RegulationE = "RegulationE",
  AsianPaymentLaws = "AsianPaymentLaws",
  AustralianPaymentLaws = "AustralianPaymentLaws",
  EuropeanPaymentLaws = "EuropeanPaymentLaws",
  CanadianPaymentLaws = "CanadianPaymentLaws",
  USPaymentLaws = "USPaymentLaws",
  PaymentCardIndustryDataSecurityStandardPCIDSS = "PaymentCardIndustryDataSecurityStandardPCIDSS",
  LimitedResourceFinancing = "LimitedResourceFinancing",
  PrivateProjectFinance = "PrivateProjectFinance",
  ProjectBonds = "ProjectBonds",
  PublicProjectFinance = "PublicProjectFinance",
  BuildOperateTransferBOT = "BuildOperateTransferBOT",
  EnergyProjectsWindSolarHydroPowerPlants = "EnergyProjectsWindSolarHydroPowerPlants",
  EnvironmentalProjectFinance = "EnvironmentalProjectFinance",
  InfrastructureAndTransportationProjects = "InfrastructureAndTransportationProjects",
  IslamicProjectFinance = "IslamicProjectFinance",
  TourismAndHospitality = "TourismAndHospitality",
  DerivativesAdviceAndCounsel = "DerivativesAdviceAndCounsel",
  SecuritizationAdviceAndCounsel = "SecuritizationAdviceAndCounsel",
  ProjectFinance = "ProjectFinance",
  AssetBackedSecuritiesABS = "AssetBackedSecuritiesABS",
  CollateralizedDebtObligationsCDOs = "CollateralizedDebtObligationsCDOs",
  CollateralizedLoanObligationsCLOs = "CollateralizedLoanObligationsCLOs",
  CommercialMortgageBackedSecuritiesCMBS = "CommercialMortgageBackedSecuritiesCMBS",
  MortgageBackedSecuritiesMBS = "MortgageBackedSecuritiesMBS",
  LandAndPropertyAgreementRefinancing = "LandAndPropertyAgreementRefinancing",
  LendingDueDiligence = "LendingDueDiligence",
  LoanDocumentationAndDueDiligence = "LoanDocumentationAndDueDiligence",
  LoanStructuringAndOrigination = "LoanStructuringAndOrigination",
  WorkOutsNoteSalesAndForeclosures = "WorkOutsNoteSalesAndForeclosures",
  ConstructionFinancing = "ConstructionFinancing",
  HousingAndUrbanDevelopmentHUDExpertise = "HousingAndUrbanDevelopmentHUDExpertise",
  ExportControls = "ExportControls",
  ExportCreditInsurance = "ExportCreditInsurance",
  ExportWorkingCapitalLoans = "ExportWorkingCapitalLoans",
  ImportControls = "ImportControls",
  LettersOfCredit = "LettersOfCredit",
  PreExportFinancing = "PreExportFinancing",
  RevolvingCreditFacilities = "RevolvingCreditFacilities",
  Sanctions = "Sanctions",
  ECCNClassificationAndResearch = "ECCNClassificationAndResearch",
  BiLateralLoanAgreements = "BiLateralLoanAgreements",
  CreditFacilitiesRevolvingCreditTermLoansLetterOfCredit = "CreditFacilitiesRevolvingCreditTermLoansLetterOfCredit",
  LettersOfCredit_Activities = "LettersOfCredit_Activities",
  RepurchaseAgreementsRepoAgreements = "RepurchaseAgreementsRepoAgreements",
  SyndicatedLoans = "SyndicatedLoans",
  AutoLoanProductsAndServices = "AutoLoanProductsAndServices",
  ConsumerDepositProducts = "ConsumerDepositProducts",
  LoanWorkouts = "LoanWorkouts",
  Mortgages = "Mortgages",
  RetailBankingProductsAndServices = "RetailBankingProductsAndServices",
  StudentLoanProductsAndServices = "StudentLoanProductsAndServices",
  DebtColectionAndRecovery = "DebtColectionAndRecovery",
  UnsecuredConsumerLoans = "UnsecuredConsumerLoans",
  ConsumerCards = "ConsumerCards",
  USConsumerFinancialProtectionBureauCFPB = "USConsumerFinancialProtectionBureauCFPB",
  AsianConsumerBankingLaws = "AsianConsumerBankingLaws",
  AustralianConsumerBankingLaws = "AustralianConsumerBankingLaws",
  CanadianConsumerBankingLaws = "CanadianConsumerBankingLaws",
  EuropeanConsumerBankingLaws = "EuropeanConsumerBankingLaws",
  UKConsumerBankingLaws = "UKConsumerBankingLaws",
  USCommunityReinvestmentActCRA = "USCommunityReinvestmentActCRA",
  RetailBankingMarketingReview = "RetailBankingMarketingReview",
  RetailBankingRegulatoryCompliance = "RetailBankingRegulatoryCompliance",
  CorporateTrusteeAdvisory = "CorporateTrusteeAdvisory",
  DebtIssuance = "DebtIssuance",
  EscrowServices = "EscrowServices",
  TrustEstablishmentAndAdministration = "TrustEstablishmentAndAdministration",
  TrustInstrumentsStructuringAndDrafting = "TrustInstrumentsStructuringAndDrafting",
  TrusteeDutiesAndResponsibilities = "TrusteeDutiesAndResponsibilities",
  EmployeeBenefitTrusts = "EmployeeBenefitTrusts",
  SecuritizationTrusts = "SecuritizationTrusts",
  USPrudentInvestorRule = "USPrudentInvestorRule",
  USTrustIndentureActOf1939TIA = "USTrustIndentureActOf1939TIA",
  USUniformTrustCodeUTC = "USUniformTrustCodeUTC",
  EuropeanRegulatoryAdvisory_RegulatoryExpertise_CorporateTrustsLendingAndBorrowing = "EuropeanRegulatoryAdvisory_RegulatoryExpertise_CorporateTrustsLendingAndBorrowing",
  CanadianRegulatoryAdvisory_RegulatoryExpertise_CorporateTrustsLendingAndBorrowing = "CanadianRegulatoryAdvisory_RegulatoryExpertise_CorporateTrustsLendingAndBorrowing",
  AsianRegulatoryAdvisory_RegulatoryExpertise_CorporateTrustsLendingAndBorrowing = "AsianRegulatoryAdvisory_RegulatoryExpertise_CorporateTrustsLendingAndBorrowing",
  AustralianRegulatoryAdvisory_RegulatoryExpertise_CorporateTrustsLendingAndBorrowing = "AustralianRegulatoryAdvisory_RegulatoryExpertise_CorporateTrustsLendingAndBorrowing",
  UKRegulatoryAdvisory_RegulatoryExpertise_CorporateTrustsLendingAndBorrowing = "UKRegulatoryAdvisory_RegulatoryExpertise_CorporateTrustsLendingAndBorrowing",
  ClearingAgreements = "ClearingAgreements",
  CreditSupportAnnex = "CreditSupportAnnex",
  CustodialAgreements = "CustodialAgreements",
  GMRAsAndMRAsDraftingAndExecution = "GMRAsAndMRAsDraftingAndExecution",
  ISDANegotiation = "ISDANegotiation",
  MSFTADraftingAndExecution = "MSFTADraftingAndExecution",
  NettingAgreementsAndOpinions = "NettingAgreementsAndOpinions",
  CommoditiesDerivatives = "CommoditiesDerivatives",
  Futures = "Futures",
  Options = "Options",
  OTCDerivatives = "OTCDerivatives",
  SWAPS = "SWAPS",
  USMarginReform = "USMarginReform",
  USRule4210RegulatoryCompliance = "USRule4210RegulatoryCompliance",
  USRegulatoryAdvisory_RegulatoryExpertise = "USRegulatoryAdvisory_RegulatoryExpertise",
  AsianRegulatoryAdvisory_RegulatoryExpertise_Derivatives = "AsianRegulatoryAdvisory_RegulatoryExpertise_Derivatives",
  AustralianRegulatoryAdvisory_RegulatoryExpertise_Derivatives = "AustralianRegulatoryAdvisory_RegulatoryExpertise_Derivatives",
  CanadianRegulatoryAdvisory_RegulatoryExpertise_Derivatives = "CanadianRegulatoryAdvisory_RegulatoryExpertise_Derivatives",
  EuropeanRegulatoryAdvisory_RegulatoryExpertise_Derivatives = "EuropeanRegulatoryAdvisory_RegulatoryExpertise_Derivatives",
  UKRegulatoryAdvisory_RegulatoryExpertise_Derivatives = "UKRegulatoryAdvisory_RegulatoryExpertise_Derivatives",
  SideLetters_Activities_SecuritiesAndPrimeBrokerage = "SideLetters_Activities_SecuritiesAndPrimeBrokerage",
  SECMarketingMaterialReview = "SECMarketingMaterialReview",
  FortyActFilings = "FortyActFilings",
  EntityFormationLLCsAndLPAs = "EntityFormationLLCsAndLPAs",
  FormPF = "FormPF",
  FundFormation = "FundFormation",
  InvestorRelations = "InvestorRelations",
  OfferingMemoranda = "OfferingMemoranda",
  PrivatePlacementMemorandum_FundActivities = "PrivatePlacementMemorandum_FundActivities",
  ProspectusAndRegulatoryFilings = "ProspectusAndRegulatoryFilings",
  SubscriptionAgreements_FundActivities = "SubscriptionAgreements_FundActivities",
  AngelSeedOrVentureCapitalFunds = "AngelSeedOrVentureCapitalFunds",
  ExchangeTradedFundsETFs = "ExchangeTradedFundsETFs",
  FundOfFunds = "FundOfFunds",
  HedgeFunds = "HedgeFunds",
  MutualFunds = "MutualFunds",
  PrivateEquityFunds = "PrivateEquityFunds",
  PrivateFunds = "PrivateFunds",
  PublicFunds = "PublicFunds",
  PublicPensionFunds = "PublicPensionFunds",
  PortfolioManagement = "PortfolioManagement",
  PrimeBrokerageEquities = "PrimeBrokerageEquities",
  PrimeBrokerageFixedIncome = "PrimeBrokerageFixedIncome",
  BrokerDealer = "BrokerDealer",
  InvestmentAdvisors = "InvestmentAdvisors",
  USExchangeActOf1934Compliance_RegulatoryExpertise_InvestmentAndWealthManagement = "USExchangeActOf1934Compliance_RegulatoryExpertise_InvestmentAndWealthManagement",
  USInvestmentAdvisersActOf1940 = "USInvestmentAdvisersActOf1940",
  AustralianRegulatoryAdvisory_RegulatoryExpertise_InvestmentAndWealthManagement = "AustralianRegulatoryAdvisory_RegulatoryExpertise_InvestmentAndWealthManagement",
  AsianRegulatoryAdvisory_RegulatoryExpertise_InvestmentAndWealthManagement = "AsianRegulatoryAdvisory_RegulatoryExpertise_InvestmentAndWealthManagement",
  CanadianRegulatoryAdvisory_RegulatoryExpertise_InvestmentAndWealthManagement = "CanadianRegulatoryAdvisory_RegulatoryExpertise_InvestmentAndWealthManagement",
  EuropeanRegulatoryAdvisory_RegulatoryExpertise_InvestmentAndWealthManagement = "EuropeanRegulatoryAdvisory_RegulatoryExpertise_InvestmentAndWealthManagement",
  UKRegulatoryAdvisory_RegulatoryExpertise_InvestmentAndWealthManagement = "UKRegulatoryAdvisory_RegulatoryExpertise_InvestmentAndWealthManagement",
  RegulatoryExaminationsAndComplianceAudits = "RegulatoryExaminationsAndComplianceAudits",
  MergersAcquisitionsAndCorporateTransactions = "MergersAcquisitionsAndCorporateTransactions",
  InsuranceLitigationSupport = "InsuranceLitigationSupport",
  PolicyFormDevelopmentAndFiling = "PolicyFormDevelopmentAndFiling",
  AgentAndBrokerLicensing = "AgentAndBrokerLicensing",
  ClaimsManagement = "ClaimsManagement",
  InsuranceProductAdvisory = "InsuranceProductAdvisory",
  OpinionLetters = "OpinionLetters",
  ReinsuranceAgreements = "ReinsuranceAgreements",
  RiskManagementProgramDevelopment = "RiskManagementProgramDevelopment",
  COIManagement = "COIManagement",
  IPInfringementInsurance = "IPInfringementInsurance",
  LifeInsuranceAndAnnuityProducts = "LifeInsuranceAndAnnuityProducts",
  MutualInsuranceAndMutualInsurer = "MutualInsuranceAndMutualInsurer",
  PropertyAndCasualtyProducts = "PropertyAndCasualtyProducts",
  WorkersCompensationInsurance = "WorkersCompensationInsurance",
  CyberAndTechnologyInsurance = "CyberAndTechnologyInsurance",
  DirectorsAndOfficersInsurance = "DirectorsAndOfficersInsurance",
  ProfessionalLiabilityInsurance = "ProfessionalLiabilityInsurance",
  HealthInsuranceProducts = "HealthInsuranceProducts",
  MedicareAdvantagePlans = "MedicareAdvantagePlans",
  MedicaidManagedCare = "MedicaidManagedCare",
  USStateInsuranceCompliance = "USStateInsuranceCompliance",
  BaselIIIBankForInternationalSettlements = "BaselIIIBankForInternationalSettlements",
  EUSolvencyIIRegulations = "EUSolvencyIIRegulations",
  InsuranceMarketEntryAndExitRequirements = "InsuranceMarketEntryAndExitRequirements",
  InsurerLicensingAndAuthorization = "InsurerLicensingAndAuthorization",
  InternationalAssociationOfInsuranceSupervisorsIAIS = "InternationalAssociationOfInsuranceSupervisorsIAIS",
  USNationalAssociationOfInsuranceCommissionersNAIC = "USNationalAssociationOfInsuranceCommissionersNAIC",
  AsianRegulatoryAdvisory_RegulatoryExpertise_Insurance = "AsianRegulatoryAdvisory_RegulatoryExpertise_Insurance",
  AustralianRegulatoryAdvisory_RegulatoryExpertise_Insurance = "AustralianRegulatoryAdvisory_RegulatoryExpertise_Insurance",
  EuropeanRegulatoryAdvisory_RegulatoryExpertise_Insurance = "EuropeanRegulatoryAdvisory_RegulatoryExpertise_Insurance",
  CanadianRegulatoryAdvisory_RegulatoryExpertise_Insurance = "CanadianRegulatoryAdvisory_RegulatoryExpertise_Insurance",
  FiftyStateSurveys = "FiftyStateSurveys",
  UKRegulatoryAdvisory_RegulatoryExpertise_Insurance = "UKRegulatoryAdvisory_RegulatoryExpertise_Insurance",
  DiscoveryAndDocumentReviewAndManagement = "DiscoveryAndDocumentReviewAndManagement",
  LegalResearchAndWriting = "LegalResearchAndWriting",
  AnalyticsAndReporting = "AnalyticsAndReporting",
  ContractLifecycleManagementCLMImplementation = "ContractLifecycleManagementCLMImplementation",
  ContractLifecycleManagementCLMProgramManagementAndMaintenance = "ContractLifecycleManagementCLMProgramManagementAndMaintenance",
  CostReductionAndBudgeting = "CostReductionAndBudgeting",
  EBilling = "EBilling",
  OutsideCounselManagement = "OutsideCounselManagement",
  ProcessManagementAndNewProcessMapping = "ProcessManagementAndNewProcessMapping",
  ProjectManagement = "ProjectManagement",
  ProgramManagement = "ProgramManagement",
  ProcessImprovementAndOptimization = "ProcessImprovementAndOptimization",
  RiskTracking = "RiskTracking",
  TemplatesPlaybooksAndOptimizations = "TemplatesPlaybooksAndOptimizations",
  ADRStrategy = "ADRStrategy",
  DiscoveryDocumentReviewAndManagement = "DiscoveryDocumentReviewAndManagement",
  OutsideCounselManagement_Activities = "OutsideCounselManagement_Activities",
  PleadingsMotionsAndDepositions = "PleadingsMotionsAndDepositions",
  PreSuitInvestigationAndPreparation = "PreSuitInvestigationAndPreparation",
  AutoWarrantyAndLemonLaw = "AutoWarrantyAndLemonLaw",
  BreachOfContractLaw = "BreachOfContractLaw",
  ConstructionLaw = "ConstructionLaw",
  ConsumerDisputes = "ConsumerDisputes",
  EmploymentLaw = "EmploymentLaw",
  EnvironmentalLaw = "EnvironmentalLaw",
  FinancialLaw = "FinancialLaw",
  GeneralLiability = "GeneralLiability",
  InsuranceCoverageDisputes = "InsuranceCoverageDisputes",
  IPLaw = "IPLaw",
  PersonalInjuryLaw = "PersonalInjuryLaw",
  PremisesLiability = "PremisesLiability",
  ProductLiability = "ProductLiability",
  ProfessionalLiabilityLaw = "ProfessionalLiabilityLaw",
  RealEstateLaw = "RealEstateLaw",
  Appeals_Activities_Litigation = "Appeals_Activities_Litigation",
  DiscoveryAndDocumentReviewAndManagement_Activities_Litigation = "DiscoveryAndDocumentReviewAndManagement_Activities_Litigation",
  LitigationAdviceAndCounsel_Activities_Litigation = "LitigationAdviceAndCounsel_Activities_Litigation",
  HighVolumeLitigation_Activities_Litigation = "HighVolumeLitigation_Activities_Litigation",
  ClassActions_Activities_Litigation = "ClassActions_Activities_Litigation",
  ArbitrationMediationADR_Activities_Litigation = "ArbitrationMediationADR_Activities_Litigation",
  OutsideCounselManagement_Activities_Litigation = "OutsideCounselManagement_Activities_Litigation",
  PleadingsMotionsAndDepositions_Activities_Litigation = "PleadingsMotionsAndDepositions_Activities_Litigation",
  PreSuitInvestigationAndPreparation_Activities_Litigation = "PreSuitInvestigationAndPreparation_Activities_Litigation",
  TrialPreparationAndSupport_Activities_Litigation = "TrialPreparationAndSupport_Activities_Litigation",
  DocketManagement_Activities_Litigation = "DocketManagement_Activities_Litigation",
  BudgetManagement_Activities_Litigation = "BudgetManagement_Activities_Litigation",
  Antitrust_TypesOfDisputes_Litigation = "Antitrust_TypesOfDisputes_Litigation",
  AutoWarrantyAndLemonLaw_TypesOfDisputes_Litigation = "AutoWarrantyAndLemonLaw_TypesOfDisputes_Litigation",
  BankingAndFinancialServices_TypesOfDisputes_Litigation = "BankingAndFinancialServices_TypesOfDisputes_Litigation",
  BreachOfContract_TypesOfDisputes_Litigation = "BreachOfContract_TypesOfDisputes_Litigation",
  ClassAction_TypesOfDisputes_Litigation = "ClassAction_TypesOfDisputes_Litigation",
  Construction_TypesOfDisputes_Litigation = "Construction_TypesOfDisputes_Litigation",
  CommercialDisputes_TypesOfDisputes_Litigation = "CommercialDisputes_TypesOfDisputes_Litigation",
  Employment_TypesOfDisputes_Litigation = "Employment_TypesOfDisputes_Litigation",
  Environmental_TypesOfDisputes_Litigation = "Environmental_TypesOfDisputes_Litigation",
  ConsumerDisputes_TypesOfDisputes_Litigation = "ConsumerDisputes_TypesOfDisputes_Litigation",
  ConsumerFinance_TypesOfDisputes_Litigation = "ConsumerFinance_TypesOfDisputes_Litigation",
  HighVolumeLitigation_TypesOfDisputes_Litigation = "HighVolumeLitigation_TypesOfDisputes_Litigation",
  InsuranceCoverageDisputes_TypesOfDisputes_Litigation = "InsuranceCoverageDisputes_TypesOfDisputes_Litigation",
  IntellectualProperty_TypesOfDisputes_Litigation = "IntellectualProperty_TypesOfDisputes_Litigation",
  GeneralLiability_TypesOfDisputes_Litigation = "GeneralLiability_TypesOfDisputes_Litigation",
  PremisesLiability_TypesOfDisputes_Litigation = "PremisesLiability_TypesOfDisputes_Litigation",
  ProductLiability_TypesOfDisputes_Litigation = "ProductLiability_TypesOfDisputes_Litigation",
  ProfessionalLiability_TypesOfDisputes_Litigation = "ProfessionalLiability_TypesOfDisputes_Litigation",
  RealEstate_TypesOfDisputes_Litigation = "RealEstate_TypesOfDisputes_Litigation",
  Securities_TypesOfDisputes_Litigation = "Securities_TypesOfDisputes_Litigation",
  WhiteCollarDisputes_TypesOfDisputes_Litigation = "WhiteCollarDisputes_TypesOfDisputes_Litigation",
  Plaintiff_LitigationRole_Litigation = "Plaintiff_LitigationRole_Litigation",
  Defendant_LitigationRole_Litigation = "Defendant_LitigationRole_Litigation",
  AncillaryTransactionDocumentation = "AncillaryTransactionDocumentation",
  BuySideDefinitiveAgreementExecutionAndNegotiation = "BuySideDefinitiveAgreementExecutionAndNegotiation",
  BuySideDueDiligence = "BuySideDueDiligence",
  DocumentAndDataRoomManagement = "DocumentAndDataRoomManagement",
  DisclosureSchedules = "DisclosureSchedules",
  FinancingAndRegulatoryApproval = "FinancingAndRegulatoryApproval",
  OfferingMemorAnda_Activities = "OfferingMemorAnda_Activities",
  PostClosingAdviceAndCounsel = "PostClosingAdviceAndCounsel",
  PreDealStrategyLOIsAndTermSheets = "PreDealStrategyLOIsAndTermSheets",
  PurchaseAgreements = "PurchaseAgreements",
  SellSideDefinitiveAgreementExecutionAndNegotiation = "SellSideDefinitiveAgreementExecutionAndNegotiation",
  SellSideDueDiligence = "SellSideDueDiligence",
  RepAndWarrantyInsuranceTermsNegotiation = "RepAndWarrantyInsuranceTermsNegotiation",
  RedFlagMemoDrafting = "RedFlagMemoDrafting",
  ShareholderAgreements = "ShareholderAgreements",
  CorporateAndInvestmentPortfolioMaintenance = "CorporateAndInvestmentPortfolioMaintenance",
  JointVentureDueDiligence = "JointVentureDueDiligence",
  AntitrustMAndAAdvisory = "AntitrustMAndAAdvisory",
  DataPrivacyMAndAAdvisory = "DataPrivacyMAndAAdvisory",
  IntellectualPropertyMAndAAdvisory = "IntellectualPropertyMAndAAdvisory",
  LaborAndEmploymentAndERISAMAndAAdvisory = "LaborAndEmploymentAndERISAMAndAAdvisory",
  PublicSecuritiesAndTransactionsMAndAAdvisory = "PublicSecuritiesAndTransactionsMAndAAdvisory",
  TaxMAndAAdvisory = "TaxMAndAAdvisory",
  Acquisition = "Acquisition",
  Divestiture = "Divestiture",
  Merger = "Merger",
  JointVenture = "JointVenture",
  ContractAndTitleReview = "ContractAndTitleReview",
  LandAndPropertyAgreementsSaleOrPurchase = "LandAndPropertyAgreementsSaleOrPurchase",
  RealEstateLeasingAgreements = "RealEstateLeasingAgreements",
  RealEstateLicensingAgreements = "RealEstateLicensingAgreements",
  RealEstatePortfolioAuditAndManagement = "RealEstatePortfolioAuditAndManagement",
  TitleObjectionLetters = "TitleObjectionLetters",
  ConveyanceAndClosingDocumentation = "ConveyanceAndClosingDocumentation",
  UCCFinancingStatements = "UCCFinancingStatements",
  DevelopmentAgreementsandREAs = "DevelopmentAgreementsandREAs",
  TransactionManagementAndDueDiligence = "TransactionManagementAndDueDiligence",
  EstoppelsAndSNDAs = "EstoppelsAndSNDAs",
  RealEstateInvestigationsAndEnforcement = "RealEstateInvestigationsAndEnforcement",
  ConstructionContractsAIAContractsAndEPC = "ConstructionContractsAIAContractsAndEPC",
  ConstructionLiens = "ConstructionLiens",
  LandUseAndZoning = "LandUseAndZoning",
  DevelopmentProjectAdvisory = "DevelopmentProjectAdvisory",
  PublicPrivatePartnershipStructuring = "PublicPrivatePartnershipStructuring",
  EnvironmentalAndRegulatoryCompliance = "EnvironmentalAndRegulatoryCompliance",
  AntitrustDueDiligence = "AntitrustDueDiligence",
  AntitrustLitigation_RegulatoryExpertise = "AntitrustLitigation_RegulatoryExpertise",
  AntitrustMergersAndAcquisitions = "AntitrustMergersAndAcquisitions",
  USClaytonAntitrustAct1914 = "USClaytonAntitrustAct1914",
  InvestigationManagement = "InvestigationManagement",
  USShermanAntitrustAct1890 = "USShermanAntitrustAct1890",
  AsianRegulatoryAdvisory_RegulatoryExpertise_AntitrustAndCompetition = "AsianRegulatoryAdvisory_RegulatoryExpertise_AntitrustAndCompetition",
  AustralianRegulatoryAdvisory_RegulatoryExpertise_AntitrustAndCompetition = "AustralianRegulatoryAdvisory_RegulatoryExpertise_AntitrustAndCompetition",
  CanadianRegulatoryAdvisory_RegulatoryExpertise_AntitrustAndCompetition = "CanadianRegulatoryAdvisory_RegulatoryExpertise_AntitrustAndCompetition",
  EuropeanRegulatoryAdvisory_RegulatoryExpertise_AntitrustAndCompetition = "EuropeanRegulatoryAdvisory_RegulatoryExpertise_AntitrustAndCompetition",
  UKRegulatoryAdvisory_RegulatoryExpertise_AntitrustAndCompetition = "UKRegulatoryAdvisory_RegulatoryExpertise_AntitrustAndCompetition",
  USFederalTradeCommissionActFTCA_RegulatoryExpertise_AntitrustAndCompetition = "USFederalTradeCommissionActFTCA_RegulatoryExpertise_AntitrustAndCompetition",
  USHartScottRodinoAntitrustImprovementsAct = "USHartScottRodinoAntitrustImprovementsAct",
  USRobinsonPatmanAct = "USRobinsonPatmanAct",
  AntiBriberyComplianceProgramDevelopment = "AntiBriberyComplianceProgramDevelopment",
  EnforcementActions = "EnforcementActions",
  InternalInvestigationsManagement = "InternalInvestigationsManagement",
  ComplianceAndEthicsProgramsPoliciesAndProcedures = "ComplianceAndEthicsProgramsPoliciesAndProcedures",
  UKBriberyAct = "UKBriberyAct",
  USForeignCorruptPracticesActFCPA = "USForeignCorruptPracticesActFCPA",
  USPatriotAct = "USPatriotAct",
  AsianRegulatoryAdvisory_RegulatoryExpertise_BriberyAndCorruption = "AsianRegulatoryAdvisory_RegulatoryExpertise_BriberyAndCorruption",
  AustralianRegulatoryAdvisory_RegulatoryExpertise_BriberyAndCorruption = "AustralianRegulatoryAdvisory_RegulatoryExpertise_BriberyAndCorruption",
  CanadianRegulatoryAdvisory_RegulatoryExpertise_BriberyAndCorruption = "CanadianRegulatoryAdvisory_RegulatoryExpertise_BriberyAndCorruption",
  EuropeanRegulatoryAdvisory_RegulatoryExpertise_BriberyAndCorruption = "EuropeanRegulatoryAdvisory_RegulatoryExpertise_BriberyAndCorruption",
  USBriberyOfPublicOfficialsAndWitnesses = "USBriberyOfPublicOfficialsAndWitnesses",
  USHobbsAct = "USHobbsAct",
  USTravelAct = "USTravelAct",
  USProgramFraudCivilRemediesAct = "USProgramFraudCivilRemediesAct",
  USRICE = "USRICE",
  USAntiKickbackStatute_RegulatoryExpertise_BriberyAndCorruption = "USAntiKickbackStatute_RegulatoryExpertise_BriberyAndCorruption",
  USBankBriberyAct = "USBankBriberyAct",
  ConsumerProtectionComplianceProgramDevelopment = "ConsumerProtectionComplianceProgramDevelopment",
  UKConsumerProtectionfromUnfairTradingRegulationsCPUT = "UKConsumerProtectionfromUnfairTradingRegulationsCPUT",
  UKConsumerRightsAct = "UKConsumerRightsAct",
  USDeceptiveAndAbusiveActsOrPracticesUDAAP = "USDeceptiveAndAbusiveActsOrPracticesUDAAP",
  USFairDebtCollectionPracticesActFDCPA = "USFairDebtCollectionPracticesActFDCPA",
  USFDA = "USFDA",
  USFederalTradeCommissionActFTCA = "USFederalTradeCommissionActFTCA",
  USTruthInLendingActTILA = "USTruthInLendingActTILA",
  AsianRegulatoryAdvisory_RegulatoryExpertise_ConsumerProtectionRegulation = "AsianRegulatoryAdvisory_RegulatoryExpertise_ConsumerProtectionRegulation",
  AustralianRegulatoryAdvisory_RegulatoryExpertise_ConsumerProtectionRegulation = "AustralianRegulatoryAdvisory_RegulatoryExpertise_ConsumerProtectionRegulation",
  CanadianRegulatoryAdvisory_RegulatoryExpertise_ConsumerProtectionRegulation = "CanadianRegulatoryAdvisory_RegulatoryExpertise_ConsumerProtectionRegulation",
  EuropeanRegulatoryAdvisory_RegulatoryExpertise_ConsumerProtectionRegulation = "EuropeanRegulatoryAdvisory_RegulatoryExpertise_ConsumerProtectionRegulation",
  USFairCreditReportingActFCRA = "USFairCreditReportingActFCRA",
  RealEstateSettlementProceduresAct = "RealEstateSettlementProceduresAct",
  DoddFrankWallStreetReform = "DoddFrankWallStreetReform",
  ConsumerProductSafetyAct = "ConsumerProductSafetyAct",
  AsianRegulatoryAdvisory_RegulatoryExpertise_EnergyRegulationAndCompliance = "AsianRegulatoryAdvisory_RegulatoryExpertise_EnergyRegulationAndCompliance",
  AustralianRegulatoryAdvisory_RegulatoryExpertise_EnergyRegulationAndCompliance = "AustralianRegulatoryAdvisory_RegulatoryExpertise_EnergyRegulationAndCompliance",
  CanadianRegulatoryAdvisory_RegulatoryExpertise_EnergyRegulationAndCompliance = "CanadianRegulatoryAdvisory_RegulatoryExpertise_EnergyRegulationAndCompliance",
  EuropeanRegulatoryAdvisory_RegulatoryExpertise_EnergyRegulationAndCompliance = "EuropeanRegulatoryAdvisory_RegulatoryExpertise_EnergyRegulationAndCompliance",
  OilAndGasAdvisory = "OilAndGasAdvisory",
  RenewablePortfolioStandardsRPSAndEnergyEfficiencyStandards = "RenewablePortfolioStandardsRPSAndEnergyEfficiencyStandards",
  UKElectricityAct1989 = "UKElectricityAct1989",
  UKRenewablesObligationROAndFeedInTariffsFiTs = "UKRenewablesObligationROAndFeedInTariffsFiTs",
  USCleanAirActCAA = "USCleanAirActCAA",
  USEnergyPolicyActOf2005 = "USEnergyPolicyActOf2005",
  USFederalEnergyRegulatoryCommissionFERC = "USFederalEnergyRegulatoryCommissionFERC",
  USPipelineAndHazardousMaterialsSafetyAdministrationPHMSA_RegulatoryExpertise = "USPipelineAndHazardousMaterialsSafetyAdministrationPHMSA_RegulatoryExpertise",
  USPublicUtilityRegulatoryPoliciesActPURPA = "USPublicUtilityRegulatoryPoliciesActPURPA",
  DisclosureAndReporting = "DisclosureAndReporting",
  EnvironmentalImpactStatements = "EnvironmentalImpactStatements",
  PolicyDevelopmentAndImplementation_Activities = "PolicyDevelopmentAndImplementation_Activities",
  RiskAssessmentsAndInternalAudits = "RiskAssessmentsAndInternalAudits",
  CDPReporting = "CDPReporting",
  EnvironmentalComplianceAdviceAndCounsel = "EnvironmentalComplianceAdviceAndCounsel",
  SocialComplianceAdviceAndCounsel = "SocialComplianceAdviceAndCounsel",
  CorporateGovernanceAdviceAndCounsel = "CorporateGovernanceAdviceAndCounsel",
  EAndCComplianceAdviceAndCounsel = "EAndCComplianceAdviceAndCounsel",
  EthicsAndComplianceProgramStrategyAndAssessment = "EthicsAndComplianceProgramStrategyAndAssessment",
  EnvironmentalEnforcementActions = "EnvironmentalEnforcementActions",
  EnvironmentalLitigation = "EnvironmentalLitigation",
  EnvironmentalCleanups = "EnvironmentalCleanups",
  EUCorporateSustainabilityReportingDirectiveCSRD = "EUCorporateSustainabilityReportingDirectiveCSRD",
  EuropeanAccessibilityAct = "EuropeanAccessibilityAct",
  EUTaxonomyRegulation = "EUTaxonomyRegulation",
  EuropeanGreenDeal = "EuropeanGreenDeal",
  OECDGuidelines = "OECDGuidelines",
  UNGlobalCompactAndGuidingPrinciples = "UNGlobalCompactAndGuidingPrinciples",
  UKModernSlaveryAct = "UKModernSlaveryAct",
  UKEnvironmentalActAndTCFD = "UKEnvironmentalActAndTCFD",
  USSECESGLaws = "USSECESGLaws",
  ToxicTort = "ToxicTort",
  UKTaskForceOnClimateRelatedFinancialDisclosuresTCFD = "UKTaskForceOnClimateRelatedFinancialDisclosuresTCFD",
  UKTheCompaniesAct2006 = "UKTheCompaniesAct2006",
  USADACompliance = "USADACompliance",
  USCleanWaterActCWA = "USCleanWaterActCWA",
  USResourceConservationAndRecoveryActRCRA = "USResourceConservationAndRecoveryActRCRA",
  AsianRegulatoryAdvisory_RegulatoryExpertise_EnvironmentalSocialAndGovernanceCompliance = "AsianRegulatoryAdvisory_RegulatoryExpertise_EnvironmentalSocialAndGovernanceCompliance",
  AustralianRegulatoryAdvisory_RegulatoryExpertise_EnvironmentalSocialAndGovernanceCompliance = "AustralianRegulatoryAdvisory_RegulatoryExpertise_EnvironmentalSocialAndGovernanceCompliance",
  CanadianRegulatoryAdvisory_RegulatoryExpertise_EnvironmentalSocialAndGovernanceCompliance = "CanadianRegulatoryAdvisory_RegulatoryExpertise_EnvironmentalSocialAndGovernanceCompliance",
  USWebContentAccessibilityGuidelinesWCAGDigitalAccessibility = "USWebContentAccessibilityGuidelinesWCAGDigitalAccessibility",
  PFAS = "PFAS",
  USCleanAirActCAA_RegulatoryExpertise_EnvironmentalSocialAndGovernanceCompliance = "USCleanAirActCAA_RegulatoryExpertise_EnvironmentalSocialAndGovernanceCompliance",
  USCERCLASuperfund = "USCERCLASuperfund",
  USEPCRA = "USEPCRA",
  USFIFRA = "USFIFRA",
  USTSCA = "USTSCA",
  CorporateTax = "CorporateTax",
  ContractsLicensesAndLeases = "ContractsLicensesAndLeases",
  IPManagement = "IPManagement",
  RiskManagement = "RiskManagement",
  BoardSupport = "BoardSupport",
  CorporateGovernance = "CorporateGovernance",
  Financing_Activities = "Financing_Activities",
  IntellectualProperty = "IntellectualProperty",
  LaborAndEmployment = "LaborAndEmployment",
  MergersAndAcquisitions = "MergersAndAcquisitions",
  ProductAdvice = "ProductAdvice",
  AILicensingAgreements = "AILicensingAgreements",
  AIPrivacyAndCybersecurityAssessmentAndPolicies = "AIPrivacyAndCybersecurityAssessmentAndPolicies",
  AIProductCounsel = "AIProductCounsel",
  AIRegulatoryCompliance_Activities = "AIRegulatoryCompliance_Activities",
  AISocialResponsibility_Activities = "AISocialResponsibility_Activities",
  AISoftwareProcurement = "AISoftwareProcurement",
  AIRiskAssessments = "AIRiskAssessments",
  InternalInvestigationsAndRiskAssessments = "InternalInvestigationsAndRiskAssessments",
  RegulatoryInquiryResponse = "RegulatoryInquiryResponse",
  MultiJurisdictionalAndCrossBorderInvestigations = "MultiJurisdictionalAndCrossBorderInvestigations",
  RegulatoryHearingsAndTestimony = "RegulatoryHearingsAndTestimony",
  SettlementNegotiationAndVoluntaryDisclosures = "SettlementNegotiationAndVoluntaryDisclosures",
  WhistleblowerComplaintsAndSelfReporting = "WhistleblowerComplaintsAndSelfReporting",
  RegulatoryExaminationsAndOnsiteVisits = "RegulatoryExaminationsAndOnsiteVisits",
  HandlingAndManagingEnforcementActions = "HandlingAndManagingEnforcementActions",
  RegulatoryChangeManagement = "RegulatoryChangeManagement",
  AsianBankingAndFinanceLaws = "AsianBankingAndFinanceLaws",
  AustralianBankingAndFinanceLaws = "AustralianBankingAndFinanceLaws",
  CanadianBankingAndFinanceLaws = "CanadianBankingAndFinanceLaws",
  ConsumerProtectionRegulatoryCompliance = "ConsumerProtectionRegulatoryCompliance",
  EuropeanBankingAndFinanceLaws = "EuropeanBankingAndFinanceLaws",
  UKBankingAndFinanceLaws = "UKBankingAndFinanceLaws",
  USBankingLaws = "USBankingLaws",
  USKYCAndAML = "USKYCAndAML",
  USSECAndBlueSkyLaws = "USSECAndBlueSkyLaws",
  USFederalBankingRegulators = "USFederalBankingRegulators",
  USSecuritiesAndInvestmentRegulation = "USSecuritiesAndInvestmentRegulation",
  CommodityFuturesTradingCommission = "CommodityFuturesTradingCommission",
  ConsumerFinancialProtectionBureau = "ConsumerFinancialProtectionBureau",
  ECCNClassification = "ECCNClassification",
  VoluntaryDisclosuresDrafting = "VoluntaryDisclosuresDrafting",
  ExportLicenseApplicationPreparation = "ExportLicenseApplicationPreparation",
  MAndATradeAndExportDueDiligence = "MAndATradeAndExportDueDiligence",
  InternalInvestigations_Activities_TradeComplianceSanctionsAndExportControls = "InternalInvestigations_Activities_TradeComplianceSanctionsAndExportControls",
  ComplianceProgramManagement = "ComplianceProgramManagement",
  TradeCompliancePoliciesAndProceduresCreation = "TradeCompliancePoliciesAndProceduresCreation",
  ExportControlPoliciesAndProceduresCreation = "ExportControlPoliciesAndProceduresCreation",
  HarmonizedTariffCodeHTCHTSClassification = "HarmonizedTariffCodeHTCHTSClassification",
  SanctionsOFACScreening = "SanctionsOFACScreening",
  ExportControls_RegulatoryExpertise = "ExportControls_RegulatoryExpertise",
  TradeCompliance = "TradeCompliance",
  Sanctions_RegulatoryExpertise = "Sanctions_RegulatoryExpertise",
  USExportAdministrationRegulationsEAR = "USExportAdministrationRegulationsEAR",
  USInternationalTrafficInArmsRegulationsITAR = "USInternationalTrafficInArmsRegulationsITAR",
  CustomsValuationAndTariffClassifications = "CustomsValuationAndTariffClassifications",
  LicensedCustomsBroker = "LicensedCustomsBroker",
  USAntiDumpingCounterveilingDuties = "USAntiDumpingCounterveilingDuties",
  AsianRegulatoryAdvisory_RegulatoryExpertise_InternationalTradeAndSanctionsInvestmentComplianceAndMarketAccess = "AsianRegulatoryAdvisory_RegulatoryExpertise_InternationalTradeAndSanctionsInvestmentComplianceAndMarketAccess",
  AustralianRegulatoryAdvisory_RegulatoryExpertise_InternationalTradeAndSanctionsInvestmentComplianceAndMarketAccess = "AustralianRegulatoryAdvisory_RegulatoryExpertise_InternationalTradeAndSanctionsInvestmentComplianceAndMarketAccess",
  EuropeanRegulatoryAdvisory_RegulatoryExpertise_InternationalTradeAndSanctionsInvestmentComplianceAndMarketAccess = "EuropeanRegulatoryAdvisory_RegulatoryExpertise_InternationalTradeAndSanctionsInvestmentComplianceAndMarketAccess",
  Incoterms = "Incoterms",
  KYCAndPoliticallyExposedPersonsPEPs = "KYCAndPoliticallyExposedPersonsPEPs",
  LatinAmericanRegulatoryAdvisory = "LatinAmericanRegulatoryAdvisory",
  UKRegulatoryAdvisory_RegulatoryExpertise_InternationalTradeAndSanctionsInvestmentComplianceAndMarketAccess = "UKRegulatoryAdvisory_RegulatoryExpertise_InternationalTradeAndSanctionsInvestmentComplianceAndMarketAccess",
  USForeignCorruptPracticesActFCPA_RegulatoryExpertise = "USForeignCorruptPracticesActFCPA_RegulatoryExpertise",
  USForeignDirectProductRule = "USForeignDirectProductRule",
  USSuspiciousActivityReportingSAR = "USSuspiciousActivityReportingSAR",
  WorldTradeOrganizationCompliance = "WorldTradeOrganizationCompliance",
  OfficeOfForeignAssetsControlOFAC = "OfficeOfForeignAssetsControlOFAC",
  RiskAssessmentsAndInternalAudits_Activities = "RiskAssessmentsAndInternalAudits_Activities",
  ProcurementControls = "ProcurementControls",
  ComplianceProgramDevelopmentAndImplementation = "ComplianceProgramDevelopmentAndImplementation",
  US340BEligibilityAndCompliance = "US340BEligibilityAndCompliance",
  US501C3EligibilityAndCompliance = "US501C3EligibilityAndCompliance",
  USAffordableCareActACA = "USAffordableCareActACA",
  USAntiKickbackStatute = "USAntiKickbackStatute",
  MedicalAffairsAndPatientEngagmeent = "MedicalAffairsAndPatientEngagmeent",
  RFPs = "RFPs",
  USHealthInsurancePortabilityAndAccountabilityActHIPAA = "USHealthInsurancePortabilityAndAccountabilityActHIPAA",
  USMedicareAndMedicaid = "USMedicareAndMedicaid",
  USStarkLaw = "USStarkLaw",
  AsianRegulatoryAdvisory_RegulatoryExpertise_HealthcareAndLifeSciencesRegulationAndCompliance = "AsianRegulatoryAdvisory_RegulatoryExpertise_HealthcareAndLifeSciencesRegulationAndCompliance",
  AustralianRegulatoryAdvisory_RegulatoryExpertise_HealthcareAndLifeSciencesRegulationAndCompliance = "AustralianRegulatoryAdvisory_RegulatoryExpertise_HealthcareAndLifeSciencesRegulationAndCompliance",
  CanadianRegulatoryAdvisory_RegulatoryExpertise_HealthcareAndLifeSciencesRegulationAndCompliance = "CanadianRegulatoryAdvisory_RegulatoryExpertise_HealthcareAndLifeSciencesRegulationAndCompliance",
  EuropeanRegulatoryAdvisory_RegulatoryExpertise_HealthcareAndLifeSciencesRegulationAndCompliance = "EuropeanRegulatoryAdvisory_RegulatoryExpertise_HealthcareAndLifeSciencesRegulationAndCompliance",
  UKRegulatoryAdvisory_RegulatoryExpertise_HealthcareAndLifeSciencesRegulationAndCompliance = "UKRegulatoryAdvisory_RegulatoryExpertise_HealthcareAndLifeSciencesRegulationAndCompliance",
  EUEMAApproval = "EUEMAApproval",
  US510KDisclosures = "US510KDisclosures",
  USFDARegistrationAndListingTitle21CFRPart807 = "USFDARegistrationAndListingTitle21CFRPart807",
  USPremarketApproval21CFRPart814 = "USPremarketApproval21CFRPart814",
  USGoodPracticeGuidelinesGxPGMPGLPGCP = "USGoodPracticeGuidelinesGxPGMPGLPGCP",
  ProductApplicationReviewActivities = "ProductApplicationReviewActivities",
  ClinicalTrialRegulatorySubmissions = "ClinicalTrialRegulatorySubmissions",
  ISORegulationAndCompliance_Expertise = "ISORegulationAndCompliance_Expertise",
  PharmacovigilanceAndPostMarketSurveillance = "PharmacovigilanceAndPostMarketSurveillance",
  QualityManagementSystemQMSCompliance = "QualityManagementSystemQMSCompliance",
  AsianRegulatoryAdvisory_Expertise_LifeSciencesRegulatory = "AsianRegulatoryAdvisory_Expertise_LifeSciencesRegulatory",
  AustralianRegulatoryAdvisory_Expertise_LifeSciencesRegulatory = "AustralianRegulatoryAdvisory_Expertise_LifeSciencesRegulatory",
  CanadianRegulatoryAdvisory_Expertise_LifeSciencesRegulatory = "CanadianRegulatoryAdvisory_Expertise_LifeSciencesRegulatory",
  EuropeanRegulatoryAdvisory_Expertise_LifeSciencesRegulatory = "EuropeanRegulatoryAdvisory_Expertise_LifeSciencesRegulatory",
  UKRegulatoryAdvisory_Expertise_LifeSciencesRegulatory = "UKRegulatoryAdvisory_Expertise_LifeSciencesRegulatory",
  ComplianceProgramDevelopment_Activities_LifeSciencesCompliance = "ComplianceProgramDevelopment_Activities_LifeSciencesCompliance",
  Investigations_Activities_LifeSciencesCompliance = "Investigations_Activities_LifeSciencesCompliance",
  RiskAssessmentsAndInternalAudits_Activities_LifeSciencesCompliance = "RiskAssessmentsAndInternalAudits_Activities_LifeSciencesCompliance",
  CompliancePolicyDevelopment_Activities_LifeSciencesCompliance = "CompliancePolicyDevelopment_Activities_LifeSciencesCompliance",
  PayorAgreements = "PayorAgreements",
  ManagedCareContracts = "ManagedCareContracts",
  ConsultingPartnershipsAndJointVentures = "ConsultingPartnershipsAndJointVentures",
  PharmacyBenefitManagementPBM = "PharmacyBenefitManagementPBM",
  ProductPricingAndReimbursement = "ProductPricingAndReimbursement",
  HEORHealthEconomicsAndOutcomes = "HEORHealthEconomicsAndOutcomes",
  FormularyStrategyAndPAndTCommitteeNavigation = "FormularyStrategyAndPAndTCommitteeNavigation",
  ValueBasedCareArrangements = "ValueBasedCareArrangements",
  PriorAuthorizationAndUtilizationManagement = "PriorAuthorizationAndUtilizationManagement",
  SupplyChainAndDistributionAgreements = "SupplyChainAndDistributionAgreements",
  CMOContractManufacturingOrganizationAgreements = "CMOContractManufacturingOrganizationAgreements",
  QualityAgreements = "QualityAgreements",
  VendorAndConfidentialityAgreements = "VendorAndConfidentialityAgreements",
  DevelopmentAndLicensingAgreements = "DevelopmentAndLicensingAgreements",
  TechnologyTransferAgreements_Expertise_LifeSciencesSupplyChain = "TechnologyTransferAgreements_Expertise_LifeSciencesSupplyChain",
  ManufacturingRegulatoryCompliance = "ManufacturingRegulatoryCompliance",
  ProductRecallsAndSupplyChainManagement = "ProductRecallsAndSupplyChainManagement",
  TechnologyTransferAgreements_AgreementTypes_ClinicalTrials = "TechnologyTransferAgreements_AgreementTypes_ClinicalTrials",
  DataUseAgreements_AgreementTypes_ClinicalTrials = "DataUseAgreements_AgreementTypes_ClinicalTrials",
  InboundAndOutboundLicensingAgreements_AgreementTypes_ClinicalTrials = "InboundAndOutboundLicensingAgreements_AgreementTypes_ClinicalTrials",
  HCPInteractions = "HCPInteractions",
  ResearchSponsorshipsAndGrants = "ResearchSponsorshipsAndGrants",
  InformedConsentAndPatientPrivacy = "InformedConsentAndPatientPrivacy",
  FDAAndEMARegulatoryStrategy = "FDAAndEMARegulatoryStrategy",
  ClinicalRegulatoryCompliance = "ClinicalRegulatoryCompliance",
  ClinicalDataManagementAndProtection = "ClinicalDataManagementAndProtection",
  ClinicalResearchOrgAgreementsCRO = "ClinicalResearchOrgAgreementsCRO",
  ClinicalTrialAgreementsCTA = "ClinicalTrialAgreementsCTA",
  ClinicalTrialAgreementPolicyAndProcedures = "ClinicalTrialAgreementPolicyAndProcedures",
  ClinicalTrialPrivacyAdviceAndCounsel = "ClinicalTrialPrivacyAdviceAndCounsel",
  GeneralAndRegulatoryAdvisory = "GeneralAndRegulatoryAdvisory",
  InvestigatorInitiatedTrialsAndCollaborativeAgreements = "InvestigatorInitiatedTrialsAndCollaborativeAgreements",
  MaterialTransferAgreementMTA = "MaterialTransferAgreementMTA",
  PreClinicalAndNonClinicalTrialAgreements = "PreClinicalAndNonClinicalTrialAgreements",
  AIMachineLearningDataLearning_Activities_IPLicensing = "AIMachineLearningDataLearning_Activities_IPLicensing",
  InboundLicensingAgreements_Activities_IPLicensing = "InboundLicensingAgreements_Activities_IPLicensing",
  LicensingDueDiligence_Activities_IPLicensing = "LicensingDueDiligence_Activities_IPLicensing",
  OutboundLicensingAgreements_Activities_IPLicensing = "OutboundLicensingAgreements_Activities_IPLicensing",
  Copyright_IPType_Activities_IPLicensing = "Copyright_IPType_Activities_IPLicensing",
  OpenSourceSEPFRANDSoftware_IPType_IPLicensing = "OpenSourceSEPFRANDSoftware_IPType_IPLicensing",
  OtherIP_IPType_IPLicensing = "OtherIP_IPType_IPLicensing",
  Patent_IPType_IPLicensing = "Patent_IPType_IPLicensing",
  Software_IPType_IPLicensing = "Software_IPType_IPLicensing",
  Trademark_IPType_IPLicensing = "Trademark_IPType_IPLicensing",
  FiftyStateSurveys_Activities_InvestigationsAndEnforcement = "FiftyStateSurveys_Activities_InvestigationsAndEnforcement",
  AgencyInteractionAndCommunication_Activities_InvestigationsAndEnforcement = "AgencyInteractionAndCommunication_Activities_InvestigationsAndEnforcement",
  ComplianceAuditsAndRiskAssessments_Activities_InvestigationsAndEnforcement = "ComplianceAuditsAndRiskAssessments_Activities_InvestigationsAndEnforcement",
  ComplianceProgramsPoliciesAndTrainings_Activities_InvestigationsAndEnforcement = "ComplianceProgramsPoliciesAndTrainings_Activities_InvestigationsAndEnforcement",
  DocumentAndEvidenceManagement_Activities_InvestigationsAndEnforcement = "DocumentAndEvidenceManagement_Activities_InvestigationsAndEnforcement",
  GovernmentAgencyResponseAndCompliance_Activities_InvestigationsAndEnforcement = "GovernmentAgencyResponseAndCompliance_Activities_InvestigationsAndEnforcement",
  GovernmentRegulation_Interpretation_Activities_InvestigationsAndEnforcement = "GovernmentRegulation_Interpretation_Activities_InvestigationsAndEnforcement",
  InvestigationManagementAndStrategy_Activities_InvestigationsAndEnforcement = "InvestigationManagementAndStrategy_Activities_InvestigationsAndEnforcement",
  RegulatoryChangeManagementAndAdvisory_Activities_InvestigationsAndEnforcement = "RegulatoryChangeManagementAndAdvisory_Activities_InvestigationsAndEnforcement",
  RiskAssessmentAndMitigation_Activities_InvestigationsAndEnforcement = "RiskAssessmentAndMitigation_Activities_InvestigationsAndEnforcement",
  WitnessAndInterviewManagement_Activities_InvestigationsAndEnforcement = "WitnessAndInterviewManagement_Activities_InvestigationsAndEnforcement",
}

export const LegalSkillDisplay: Record<LegalSkill, string> = {
  [LegalSkill.CopyrightAdviceAndCounsel]: "Advice & Counsel",
  [LegalSkill.CopyrightEnforcement]: "Enforcement",
  [LegalSkill.CopyrightFilingsRegistrationAndAssignment]: "Filings, Registration & Assignment",
  [LegalSkill.CopyrightFreedomToOperate]: "Freedom to Operate",
  [LegalSkill.CopyrightInboundLicencing]: "Inbound Licensing Agreements",
  [LegalSkill.CopyrightOutboundLicensing]: "Outbound Licensing Agreements",
  [LegalSkill.TrademarkAdviceAndCounsel]: "Advice & Counsel",
  [LegalSkill.TrademarkApplicationsRegistrationsAndAssignments]: "Applications, Registrations & Assignments",
  [LegalSkill.TrademarkEnforcementCeaseAndDesistLettersAndInfringementMatters]: "Enforcement: Cease and Desist Letters & Infringement Matters",
  [LegalSkill.TrademarkEnforcementOppositionsInvalidationsAndCancellations]: "Enforcement: Oppositions, Invalidations & Cancellations",
  [LegalSkill.TrademarkSearchAndClearance]: "Search & Clearance",
  [LegalSkill.TrademarkFreedomToOperate]: "Freedom to Operate",
  [LegalSkill.TrademarkInboundLicencing]: "Inbound Licensing Agreements",
  [LegalSkill.TrademarkOutboundLicensing]: "Outbound Licensing Agreements",
  [LegalSkill.AIMachineLearningDataLearningAdviceAndCounsel_PatentActivities]: "AI, Machine-Learning, Data-Learning Advice & Counsel",
  [LegalSkill.DueDiligenceAssessments]: "Mergers, Acquisitions & Due Diligence",
  [LegalSkill.FreedomToOperate_PatentActivities]: "Freedom to Operate, Patentability Reports and Landscape Assessments",
  [LegalSkill.OutsideCounselManagement_PatentActivities]: "Outside Counsel Management",
  [LegalSkill.InternationalPatentProsecution]: "International Patent Prosecution",
  [LegalSkill.InfringementMatters]: "Infringement Matters",
  [LegalSkill.NDAsMTAsJDAsEtc]: "Commercial Agreements",
  [LegalSkill.PatentInboundLicensing]: "Patent Inbound Licensing",
  [LegalSkill.PatentOutboundLicensing]: "Patent Outbound Licensing",
  [LegalSkill.PatentPortfolioManagement]: "Patent Portfolio Management",
  [LegalSkill.PatentPreparation]: "Patent Preparation & Prosecution",
  [LegalSkill.PatentSearching]: "Patent Searching & Opinions",
  [LegalSkill.PatentValuation]: "Patent Valuation",
  [LegalSkill.PatentAdviceAndCounsel]: "Patent Advice & Counsel",
  [LegalSkill.TradeSecretAdviceAndCounsel_PatentActivities]: "Trade Secret Advice & Counsel",
  [LegalSkill.Aerospace]: "Aerospace Patents",
  [LegalSkill.Biology]: "Biology Patents",
  [LegalSkill.Biotech]: "Biotech Patents",
  [LegalSkill.Chemical]: "Chemical Patents",
  [LegalSkill.ComputerHardware]: "Electrical - Computer Hardware",
  [LegalSkill.Mechanical]: "Mechanical Patents",
  [LegalSkill.Pharmaceuticals]: "Pharmaceuticals Patents",
  [LegalSkill.Physics]: "Physics Patents",
  [LegalSkill.Software_PatentType]: "Electrical - AI & Software",
  [LegalSkill.Appeals_LitigationActivities_IntellectualPropertyLitigation]: "Appeals",
  [LegalSkill.DiscoveryDocumentReviewAndManagement_LitigationActivities_IntellectualPropertyLitigation]: "Discovery, Document Review & Management",
  [LegalSkill.LitigationAdviceAndCounsel_LitigationActivities_IntellectualPropertyLitigation]: "Litigation Advice & Counsel",
  [LegalSkill.NegotiationSettlementMediationAndAlternativeDisputeResolution_LitigationActivities_IntellectualPropertyLitigation]: "Negotiation, Settlement, Mediation & Alternative Dispute Resolution",
  [LegalSkill.OutsideCounselManagement_LitigationActivities_IntellectualPropertyLitigation]: "Outside Counsel Management",
  [LegalSkill.PleadingsMotionsAndDepositions_LitigationActivities_IntellectualPropertyLitigation]: "Pleadings, Motions & Depositions",
  [LegalSkill.PreSuitInvestigationAndPreparation_LitigationActivities_IntellectualPropertyLitigation]: "Pre-Suit Investigation & Preparation",
  [LegalSkill.TrialsAndArbitrations_LitigationActivities_IntellectualPropertyLitigation]: "Trials & Arbitrations",
  [LegalSkill.US401K]: "U.S. 401(k)",
  [LegalSkill.USEmployeeRetirementIncomeSecuritiesActERISA]: "U.S. Employee Retirement Income Securities Act (ERISA)",
  [LegalSkill.USEmployeeStockOwnershipPlanESOPAndProfitSharing]: "U.S. Employee Stock Ownership Plan (ESOP) & Profit Sharing",
  [LegalSkill.ExecutiveCompensationAndBenefits]: "Executive Compensation & Benefits",
  [LegalSkill.PhantomStockSpecializedCompensation]: "Phantom Stock & Specialized Compensation",
  [LegalSkill.HealthPlans]: "Health Plans",
  [LegalSkill.PensionPlans]: "Pension Plans",
  [LegalSkill.CafeteriaPlans]: "Cafeteria Plans",
  [LegalSkill.AsianBenefitsExpertise]: "Asian Benefits Expertise",
  [LegalSkill.AustralianBenefitsExpertise]: "Australian Benefits Expertise",
  [LegalSkill.CanadianBenefitsExpertise]: "Canadian Benefits Expertise",
  [LegalSkill.EuropeanBenefitsExpertise]: "European Benefits Expertise",
  [LegalSkill.UKBenefitsExpertise]: "U.K. Benefits Expertise",
  [LegalSkill.HIPAACompliance_EmployeeBenefitsERISACompensationBenefitsAndPensions]: "HIPAA Compliance",
  [LegalSkill.ACACompliance]: "Affordable Care Act Compliance",
  [LegalSkill.ManagingWorkplaceInvestigations]: "Managing Workplace Investigations",
  [LegalSkill.ConductingWorkplaceInvestigations]: "Conducting Workplace Investigations",
  [LegalSkill.PolicyDevelopmentAndTraining]: "Policy Development & Training",
  [LegalSkill.AdministrativeChargesAndProceedingsEEOCNLRBOSHA]: "Administrative Charges & Proceedings (EEOC, NLRB, OSHA)",
  [LegalSkill.USCaliforniaLAndEExpertise]: "U.S. California L&E Expertise",
  [LegalSkill.ContingentWorkforceExperience]: "Contingent Workforce Experience",
  [LegalSkill.EmploymentAgreementsRestrictiveCovenantsSeveranceAgreementsEtc]: "Employment Agreements (Restrictive Covenants, Severance Agreements, etc.)",
  [LegalSkill.EmploymentLitigation]: "Employment Litigation",
  [LegalSkill.EmploymentRegulatoryCompliance]: "Employment Regulatory Compliance",
  [LegalSkill.ExternalAuditsDOLEEOCOSHA]: "External Audits (DOL, EEOC, OSHA)",
  [LegalSkill.Immigration]: "Immigration Legal Counsel",
  [LegalSkill.UKEmploymentExpertise]: "U.K. Employment Expertise",
  [LegalSkill.EuropeanEmploymentExpertise]: "European Employment Expertise",
  [LegalSkill.AsianEmploymentExpertise]: "Asian Employment Expertise",
  [LegalSkill.AustralianEmploymentExpertise]: "Australian Employment Expertise",
  [LegalSkill.CanadianEmploymentExpertise]: "Canadian Employment Expertise",
  [LegalSkill.LeaveAccommodationsAndUSFMLA]: "Leave, Accommodations & U.S. FMLA",
  [LegalSkill.PoliciesPlaybooksHandbooksAndTraining]: "Policies, Playbooks, Handbooks & Training",
  [LegalSkill.ReductionsInForceRIFsAndReorgs]: "Reductions in Force (RIFs) & Reorgs",
  [LegalSkill.WageAndHourLaws]: "Wage & Hour Laws",
  [LegalSkill.PostDivestitureHRCounseling]: "Post-divestiture HR Counseling",
  [LegalSkill.TitleVIIExpertise]: "Title VII Expertise",
  [LegalSkill.PayEquityAndTransparency]: "Pay Equity & Transparency",
  [LegalSkill.EmployeePrivacyAndTechnologyCounseling]: "Employee Privacy & Technology Counseling",
  [LegalSkill.LaborAdviceAndCounsel]: "Labor Advice & Counsel",
  [LegalSkill.LaborInvestigations]: "Labor Investigations",
  [LegalSkill.LaborNegotiationAndCollectiveBargaining]: "Labor Negotiation & Collective Bargaining",
  [LegalSkill.LaborPoliciesAndProcedures]: "Labor Policies & Procedures",
  [LegalSkill.LaborTraining]: "Labor Training",
  [LegalSkill.AdministrationOrders]: "Administration Orders",
  [LegalSkill.BankruptcyAndInsolvencyLitigation]: "Bankruptcy & Insolvency Litigation",
  [LegalSkill.CompanyVoluntaryArrangementsCVAs]: "Company Voluntary Arrangements (CVAs)",
  [LegalSkill.DebtorCreditorDisputes]: "Debtor - Creditor Disputes",
  [LegalSkill.ProvisionalLiquidation]: "Provisional Liquidation",
  [LegalSkill.Receiverships]: "Receivership Legal Counsel",
  [LegalSkill.SchemesOfArrangement]: "Schemes of Arrangement",
  [LegalSkill.SideLetters]: "Side Letters",
  [LegalSkill.Administration]: "Bankruptcy Administration Legal Counsel",
  [LegalSkill.Chapter11ReorganizationAndStrategicCorporateRestructuring]: "Chapter 11, Reorganization & Strategic Corporate Restructuring",
  [LegalSkill.Chapter13]: "Chapter 13",
  [LegalSkill.Chapter7]: "Chapter 7",
  [LegalSkill.CompanyVoluntaryArrangementCVA]: "Company Voluntary Arrangement (CVA)",
  [LegalSkill.IndividualVoluntaryArrangementIVA]: "Individual Voluntary Arrangement (IVA)",
  [LegalSkill.LiquidationCompulsoryAndVoluntary]: "Liquidation (Compulsory & Voluntary)",
  [LegalSkill.Receivership]: "Receivership Legal Counsel",
  [LegalSkill.DueDiligence]: "Due Diligence",
  [LegalSkill.LegalOpinionsAndComfortLetters]: "Legal Opinions & Comfort Letters",
  [LegalSkill.OfferingDocumentDrafting]: "Offering Document Drafting",
  [LegalSkill.OperativeDocumentDraftingMBSABS]: "Operative Document Drafting (MBS / ABS)",
  [LegalSkill.ProgramTrading]: "Program Trading",
  [LegalSkill.SubscriptionAgreements]: "Subscription Agreements",
  [LegalSkill.TradingDeskAdviceAndCounsel]: "Trading Desk Advice & Counsel",
  [LegalSkill.TransactionManagement]: "Transaction Management",
  [LegalSkill.TransactionDocumentationNegotiationABSMBS]: "Transaction Documentation Negotiation (ABS or MBS)",
  [LegalSkill.TransactionDocumentationDraftingABSMBS]: "Transaction Documentation Drafting (ABS or MBS)",
  [LegalSkill.CommitmentLetters]: "Commitment Letters",
  [LegalSkill.CreditAgreements]: "Credit Agreements",
  [LegalSkill.HedgingAgreements]: "Hedging Agreements",
  [LegalSkill.IntercreditorAgreements]: "Intercreditor Agreements",
  [LegalSkill.TermSheets]: "Term Sheets",
  [LegalSkill.MezzanineFinance]: "Mezzanine Finance",
  [LegalSkill.SeniorSecuredLoans]: "Senior Secured Loans",
  [LegalSkill.PrivateIssuances]: "Private Issuances",
  [LegalSkill.PublicIssuances]: "Public Issuances",
  [LegalSkill.BondsHighYield]: "Bonds (High Yield)",
  [LegalSkill.BondsInvestmentGrade]: "Bonds (Investment Grade)",
  [LegalSkill.MortgageOrOtherAssetBackedSecuritiesMBSABS]: "Mortgage & Other Asset-Backed Securities (MBS / ABS)",
  [LegalSkill.EuropeanRegulatoryAdvisory]: "European Regulatory Advisory",
  [LegalSkill.UKRegulatoryAdvisory]: "U.K. Regulatory Advisory",
  [LegalSkill.AsianRegulatoryAdvisory]: "China Regulatory Advisory & CCP Law",
  [LegalSkill.AustralianRegulatoryAdvisory]: "Australian Regulatory Advisory",
  [LegalSkill.CanadianRegulatoryAdvisory]: "Canadian Regulatory Advisory",
  [LegalSkill.USExchangeActOf1934Compliance]: "U.S. Exchange Act of 1934 Compliance",
  [LegalSkill.USSecuritiesActOf1933Compliance]: "U.S. Securities Act of 1933 Compliance",
  [LegalSkill.DueDiligence_Activities_EquityCapitalMarkets]: "Due Diligence",
  [LegalSkill.IssuanceOfEquitySecurities]: "Issuance of Equity Securities",
  [LegalSkill.IssuanceProgramDevelopment]: "Issuance Program Development",
  [LegalSkill.PrivatePlacementMemorandum]: "Private Placement Memorandum",
  [LegalSkill.StructuringAndDraftingOfEquityOfferings]: "Structuring & Drafting of Equity Offerings",
  [LegalSkill.InitialPublicOfferingsIPOs]: "Initial Public Offerings (IPOs)",
  [LegalSkill.SecondaryOfferings]: "Secondary & At-the-market (ATM) Offerings",
  [LegalSkill.BlockTrades]: "Block Trades",
  [LegalSkill.CashEquitiesAndStocks]: "Cash Equities & Stocks",
  [LegalSkill.ConvertibleStock]: "Convertible Stock",
  [LegalSkill.EuropeanRegulatoryAdvisory_RegulatoryExpertise]: "European Regulatory Advisory",
  [LegalSkill.CanadianRegulatoryAdvisory_RegulatoryExpertise]: "Canadian Regulatory Advisory",
  [LegalSkill.UKRegulatoryAdvisory_RegulatoryExpertise]: "U.K. Regulatory Advisory",
  [LegalSkill.AsianRegulatoryAdvisory_RegulatoryExpertise]: "Asian Regulatory Advisory",
  [LegalSkill.AustralianRegulatoryAdvisory_RegulatoryExpertise]: "Australian Regulatory Advisory",
  [LegalSkill.TheInvestmentCompanyActof1940Compliance]: "The Investment Company Act of 1940 Compliance",
  [LegalSkill.USExchangeActOf1934Compliance_RegulatoryExpertise]: "U.S. Exchange Act of 1934 Compliance",
  [LegalSkill.USSecuritiesActOf1933Compliance_RegulatoryExpertise]: "U.S. Securities Act of 1933 Compliance",
  [LegalSkill.AdTechTransactions]: "AdTech Transactions",
  [LegalSkill.BehavioralAdvertising]: "Behavioral Advertising",
  [LegalSkill.ConsumerDataRegulatoryCompliance]: "Consumer Data Regulatory Compliance",
  [LegalSkill.AdvertisingComplianceReview]: "Advertising Compliance Review",
  [LegalSkill.DataMonetization]: "Data Monetization",
  [LegalSkill.DataPartnerships]: "Data Partnerships",
  [LegalSkill.EUDigitalServicesAct]: "E.U. Digital Services Act",
  [LegalSkill.AdTechPrivacy]: "AdTech Privacy",
  [LegalSkill.MobilePlatforms]: "Mobile Platforms",
  [LegalSkill.DirectProcurementAgreements]: "Direct Procurement Agreements",
  [LegalSkill.EBAOutsourcing]: "EBA Outsourcing",
  [LegalSkill.IndirectProcurementAgreements]: "Indirect Procurement Agreements",
  [LegalSkill.InfrastructurePlatformLicensingAgreements]: "Infrastructure Platform Licensing Agreements",
  [LegalSkill.ITProcurementAgreements]: "IT Procurement Agreements",
  [LegalSkill.PublicProcurement]: "Public Procurement",
  [LegalSkill.VendorAndSupplierAgreements]: "Vendor & Supplier Agreements",
  [LegalSkill.ThirdPartyRiskAssessmentMitigation]: "Third-Party Risk Assessment & Mitigation",
  [LegalSkill.SourcingPartnerAnalysis]: "Sourcing Partner Analysis",
  [LegalSkill.OutsourcedRiskScreeningTool]: "Outsourced Risk Screening Tool Implementation & Ongoing Monitoring",
  [LegalSkill.SupplierSustainabilityScore]: "Supplier Sustainability Score Assessment & Development",
  [LegalSkill.AdTechProductLaunch]: "AdTech Product Launch",
  [LegalSkill.AIAndMachineLearningMLProducts]: "AI & Machine Learning (ML) Products",
  [LegalSkill.AIRegulatoryCompliance]: "AI Regulatory Compliance",
  [LegalSkill.AISocialResponsibility]: "AI Social Responsibility",
  [LegalSkill.B2BProducts]: "B2B Products",
  [LegalSkill.B2CProducts]: "B2C Products",
  [LegalSkill.ConsumerProtection]: "Consumer Protection",
  [LegalSkill.ContentModeration]: "Content Moderation",
  [LegalSkill.DigitalAccessibilityCounselWCAG]: "Digital Accessibility (WCAG)",
  [LegalSkill.DigitalMarketingAct]: "Digital Marketing Act (DMA)",
  [LegalSkill.DigitalServicesAct]: "Digital Services Act (DSA)",
  [LegalSkill.EUDataAct]: "EU Data Act",
  [LegalSkill.Hardware]: "Hardware Product Legal Counsel",
  [LegalSkill.MarketingCompliance]: "Marketing Compliance",
  [LegalSkill.OnlineSafetyAct]: "Online Safety Act",
  [LegalSkill.PaymentAndFintechProducts]: "Payment & Fintech Products",
  [LegalSkill.Payments_Expertise_ProductCounsel]: "Payments",
  [LegalSkill.Section230CDA]: "Section 230 (Communications Decency Act)",
  [LegalSkill.SocialMediaOrPlatformProductExperience]: "Social Media or Platform Product Experience",
  [LegalSkill.Software]: "Software Product Legal Counsel",
  [LegalSkill.TrustAndSafety]: "Trust & Safety",
  [LegalSkill.UXUIReview]: "UX / UI Review",
  [LegalSkill.VRARDevice]: "VR/AR Device",
  [LegalSkill.SupplierDistributorAndManufacturerAgreements]: "Supplier, Distributor & Manufacturer Agreements",
  [LegalSkill.VendorAndServiceAgreements_AgreementTypes]: "Vendor & Service Agreements",
  [LegalSkill.ElectricVehicles]: "Electric Vehicles",
  [LegalSkill.Maritime]: "Supply Chain Maritime Legal Counsel",
  [LegalSkill.TransportationRegulatoryCompliance]: "Transportation Regulatory Compliance",
  [LegalSkill.TruckingRailAndAutomotive]: "Trucking, Rail & Automotive",
  [LegalSkill.LifecycleRiskManagement]: "Lifecycle Risk Management",
  [LegalSkill.OnboardingVendorDueDiligence]: "Onboarding Vendor Due Diligence",
  [LegalSkill.ThirdPartyRiskManagementSoftwareSelectionImplementation]: "Third-Party Risk Management, Software Selection & Implementation",
  [LegalSkill.ThirdPartySustainabilityScoreAssessmentDevelopment]: "Third-Party Sustainability Score Assessment & Development",
  [LegalSkill.ThirdPartyRiskEvaluation]: "Third-Party Risk Evaluation, Monitoring, & Advice",
  [LegalSkill.BrandProtection]: "Brand Protection",
  [LegalSkill.CampaignCreationAdvisory]: "Campaign Creation Advisory",
  [LegalSkill.ProductLaunchAdvisory]: "Product Launch Advisory",
  [LegalSkill.AdvertisingComplianceReview_Activities]: "Advertising Compliance Review",
  [LegalSkill.MarketingPrivacyCounsel]: "Marketing Privacy Counsel",
  [LegalSkill.InfluencerAgreements]: "Influencer Agreements",
  [LegalSkill.LicensingAgreements]: "Licensing Agreements",
  [LegalSkill.MarketingAndSponsorshipAgreements]: "Marketing & Sponsorship Agreements",
  [LegalSkill.SweepstakesAndContestsRulesAndAgreements]: "Sweepstakes & Contests Rules and Agreements",
  [LegalSkill.AustralianRegulatoryAdvisory_RegulatoryExpertise_AdvertisingMarketingAndPromotionalReview]: "Australian Regulatory Advisory",
  [LegalSkill.CanadianRegulatoryAdvisory_RegulatoryExpertise_AdvertisingMarketingAndPromotionalReview]: "Canadian Regulatory Advisory",
  [LegalSkill.EuropeanRegulatoryAdvisory_RegulatoryExpertise_AdvertisingMarketingAndPromotionalReview]: "European Regulatory Advisory",
  [LegalSkill.UKRegulatoryAdvisory_RegulatoryExpertise_AdvertisingMarketingAndPromotionalReview]: "U.K. Regulatory Advisory",
  [LegalSkill.AsianRegulatoryAdvisory_RegulatoryExpertise_AdvertisingMarketingAndPromotionalReview]: "Asian Regulatory Advisory",
  [LegalSkill.USTelephoneConsumerProtectionActTCPACompliance]: "U.S. Telephone Consumer Protection Act (TCPA) Compliance",
  [LegalSkill.USFDAAdvisory_RegulatoryExpertise]: "U.S. FDA Advisory",
  [LegalSkill.USTelemarketingSalesRuleTSRCompliance]: "U.S. Telemarketing Sales Rule (TSR) Compliance",
  [LegalSkill.USFTCAdvisory]: "U.S. FTC Advisory",
  [LegalSkill.CloudAndSaaSAgreements]: "Cloud & SaaS Agreements",
  [LegalSkill.EndUserLicenseAgreementsEULA]: "End User License Agreements (EULA)",
  [LegalSkill.InboundLicensing]: "Inbound Licensing",
  [LegalSkill.OutboundLicensing]: "Outbound Licensing",
  [LegalSkill.SoftwareAgreements]: "Software Agreements",
  [LegalSkill.StrategicPartnerships]: "Strategic Partnerships",
  [LegalSkill.ITVendorContracts]: "IT Vendor Contracts",
  [LegalSkill.PaaSIaaSAgreements]: "PaaS/IaaS Agreements",
  [LegalSkill.TemplateAndPlaybookCreation_Expertise_CloudSaaSSoftwareLicensing]: "Template & Playbook Creation",
  [LegalSkill.ArtificialIntelligenceAndMachineLearningAIAndML]: "Artificial Intelligence & Machine Learning (AI & ML)",
  [LegalSkill.B2B]: "Tech Transactions B2B Legal Counsel",
  [LegalSkill.B2C]: "Tech Transactions B2C Legal Counsel",
  [LegalSkill.EmergingTechnology]: "Emerging Technology",
  [LegalSkill.BlockchainAndCryptocurrency]: "Blockchain & Cryptocurrency",
  [LegalSkill.Electronics]: "Electronics Legal Counsel",
  [LegalSkill.GeneralTech]: "General Tech",
  [LegalSkill.Hardware_IndustryExperience]: "Hardware",
  [LegalSkill.Semiconductors]: "Semiconductor Legal Counsel",
  [LegalSkill.SaaSAndSoftware]: "SaaS, Software & Internet",
  [LegalSkill.ContractDrafting]: "Contract Review & Drafting",
  [LegalSkill.ContractManagementSystemCMSSelectionAndLaunch]: "Contract Management System (CMS) Selection & Launch",
  [LegalSkill.ContractNegotiation]: "Contract Negotiation",
  [LegalSkill.ContractTemplatesAndPlaybooks]: "Contract Templates & Playbooks",
  [LegalSkill.BreachOfContractDisputes]: "Breach of Contract Disputes",
  [LegalSkill.TrainingSalesonContracts]: "Training Sales on Contracts",
  [LegalSkill.DistributionAgreements_ContractTypes]: "Distribution Agreements",
  [LegalSkill.EntertainmentContractsContentProductionCollaboration]: "Entertainment Contracts (Content, Production, Collaboration)",
  [LegalSkill.MasterServiceAgreementsMSAs]: "Master Service Agreements (MSAs)",
  [LegalSkill.NonDisclosureAgreementsNDAs]: "Non-Disclosure Agreements (NDAs)",
  [LegalSkill.ProductPurchaseAgreementsGoods]: "Product Purchase Agreements (Goods)",
  [LegalSkill.ProfessionalServiceAgreements]: "Professional Service Agreements",
  [LegalSkill.SalesAndVendorAgreementsServices]: "Sales & Vendor Agreements (Services)",
  [LegalSkill.StatementsOfWorkSOWs]: "Statements of Work (SOWs)",
  [LegalSkill.ContractManagementAndAdministration]: "Contract Management & Administration",
  [LegalSkill.Environmental]: "Nuclear Energy Environmental Legal Counsel",
  [LegalSkill.NuclearSafetyAndLiability]: "Nuclear Safety & Liability",
  [LegalSkill.NuclearTechnology]: "Nuclear Technology",
  [LegalSkill.NuclearTrade]: "Nuclear Trade",
  [LegalSkill.Permitting]: "Nuclear Energy Permitting Legal Counsel",
  [LegalSkill.PolicyCreationAndAdvocacy]: "Policy Creation & Advocacy",
  [LegalSkill.RegulatoryAdvisory_AreaOfExpertise]: "Regulatory Advisory",
  [LegalSkill.WasteDisposal]: "Waste Disposal",
  [LegalSkill.AustralianRegulatoryAdvisory_RegulatoryExpertise_EnergyOilAndGas]: "Australian Regulatory Advisory",
  [LegalSkill.AsianRegulatoryAdvisory_RegulatoryExpertise_EnergyOilAndGas]: "Asian Regulatory Advisory",
  [LegalSkill.CanadianRegulatoryAdvisory_RegulatoryExpertise_EnergyOilAndGas]: "Canadian Regulatory Advisory",
  [LegalSkill.EuropeanRegulatoryAdvisory_RegulatoryExpertise_EnergyOilAndGas]: "European Regulatory Advisory",
  [LegalSkill.UKRegulatoryAdvisory_RegulatoryExpertise_EnergyOilAndGas]: "U.K. Regulatory Advisory",
  [LegalSkill.USRegulatoryAdvisory]: "U.S. Federal Energy Regulatory Commission (FERC)",
  [LegalSkill.NorthAmericanElectricReliabilityCorporation_RegulatoryExpertise_EnergyOilAndGas]: "North American Electric Reliability Corporation (NERC)",
  [LegalSkill.Financing]: "Oil and Gas Financing Legal Counsel",
  [LegalSkill.OilFieldServices]: "Oil Field Services",
  [LegalSkill.ProcessingAndRefining]: "Processing & Refining",
  [LegalSkill.SalesAgreements]: "Commercial Contracts - Sales Agreements",
  [LegalSkill.Regulatory_Activities_EnergyOilAndGas]: "Regulatory",
  [LegalSkill.Offshore_Activities_EnergyOilAndGas]: "Offshore",
  [LegalSkill.Onshore_Activities_EnergyOilAndGas]: "Onshore",
  [LegalSkill.InflationReductionAct]: "U.S. Inflation Reduction Act",
  [LegalSkill.InternationalExperience_Activities_EnergyOilAndGas]: "International Experience",
  [LegalSkill.Pipeline_Activities_EnergyOilAndGas]: "Pipeline",
  [LegalSkill.ConcessionAgreementsFarmOutAndFarmIn]: "Concession Agreements, Farm-Out & Farm-In",
  [LegalSkill.NAESBs_Activities_EnergyOilAndGas]: "NAESBs",
  [LegalSkill.ISDAs_Activities_EnergyOilAndGas]: "ISDAs",
  [LegalSkill.EngineeringProcurementAndConstructionEPC_Activities_EnergyOilAndGas]: "Engineering, Procurement & Construction (EPC)",
  [LegalSkill.GulfOfMexicoExperience]: "Gulf of Mexico Experience",
  [LegalSkill.Chemicals_Activities_EnergyOilAndGas]: "Chemicals",
  [LegalSkill.Railroad_Activities_EnergyOilAndGas]: "Railroad",
  [LegalSkill.CommercialContractsOther_Activities_EnergyOilAndGas]: "Commercial Contracts - Other (NDA's, SOW's, MSAs, etc)",
  [LegalSkill.RealEstate_Activities_EnergyOilAndGas]: "Real Estate",
  [LegalSkill.TransportationAgreements_Activities_EnergyOilAndGas]: "Commercial Contracts - Transportation Agreements",
  [LegalSkill.SupplyChain_Activities_EnergyOilAndGas]: "Supply Chain",
  [LegalSkill.CarbonCaptureAndStorageCCS]: "Carbon Capture & Storage (CCS)",
  [LegalSkill.NaturalGas]: "Natural Gas",
  [LegalSkill.LiquefiedNaturalGasLNG]: "Liquefied Natural Gas (LNG)",
  [LegalSkill.Oil]: "Oil Legal Counsel",
  [LegalSkill.Hydrocarbon]: "Hydrocarbon Legal Counsel",
  [LegalSkill.LandfillGas]: "Landfill Gas",
  [LegalSkill.Downstream]: "Oil and Gas Downstream Operations Legal Counsel",
  [LegalSkill.Midstream]: "Oil and Gas Midstream Operations Legal Counsel",
  [LegalSkill.Upstream]: "Oil and Gas Upstream Operations Legal Counsel",
  [LegalSkill.CommercialContractsOtherProcurementAgreementsMSAsEtc]: "Commercial Contracts - Other (Procurement Agreements, MSAs, etc)",
  [LegalSkill.CommercialContractsPowerPurchaseAgreementsPPAs]: "Commercial Contracts - Power Purchase Agreements (PPAs)",
  [LegalSkill.ConcessionAgreementsFarmoutAndFarmin]: "Concession Agreements, Farm-Out & Farm-In",
  [LegalSkill.EngineeringProcurementAndConstructionEPC]: "Engineering, Procurement & Construction (EPC)",
  [LegalSkill.JointVenturesAndCorporateStructure]: "Joint Ventures & Corporate Structure",
  [LegalSkill.ProjectFinancing]: "Project Finance",
  [LegalSkill.RealEstate]: "Real Estate",
  [LegalSkill.CommercialContractsFPPA]: "Commercial Contracts - Financial Power Purchase Agreements (FPPA's)",
  [LegalSkill.CommercialContractsVPPA]: "Commercial Contracts - Virtual Power Purchase Agreements (VPPA's)",
  [LegalSkill.CommercialContractsInterconnectionAgreements]: "Commercial Contracts - Interconnection Agreements",
  [LegalSkill.NAESBs_Activities_EnergyRenewable]: "NAESBs",
  [LegalSkill.ISDAs_Activities_EnergyRenewable]: "ISDAs",
  [LegalSkill.EnergyTrading]: "Energy Trading",
  [LegalSkill.BatteryEnergyStorageSystemBESS]: "Battery Energy Storage System (BESS)",
  [LegalSkill.RenewableEnergyCertificateREC]: "Renewable Energy Certificate (REC's)",
  [LegalSkill.SupplyChain_Activities_EnergyRenewable]: "Supply Chain",
  [LegalSkill.BuildTransferAgreementsBTAs]: "Build Transfer Agreements (BTAs)",
  [LegalSkill.BatteryStorage]: "Battery Storage",
  [LegalSkill.BiomassAndWaste]: "Biomass & Waste",
  [LegalSkill.Hydrogen]: "Hydrogen Energy Legal Counsel",
  [LegalSkill.OffshoreWind]: "Offshore Wind",
  [LegalSkill.OnshoreWind]: "Onshore Wind",
  [LegalSkill.RetailEnergy]: "Retail Energy",
  [LegalSkill.Solar]: "Solar Energy Legal Counsel",
  [LegalSkill.Utility_EnergyType_EnergyRenewable]: "Utility",
  [LegalSkill.RenewableNaturalGasRNG]: "Renewable Natural Gas (RNG)",
  [LegalSkill.USERCOTAndPUCAndotherISOs]: "U.S. Texas ERCOT & PUC (and other ISOs)",
  [LegalSkill.USFederalEnergyRegulatoryCommissionFERC_RegulatoryExpertise_EnergyRenewable]: "U.S. Federal Energy Regulatory Commission (FERC)",
  [LegalSkill.NorthAmericanElectricReliabilityCorporation_RegulatoryExpertise_EnergyRenewable]: "North American Electric Reliability Corporation (NERC)",
  [LegalSkill.USPipelineAndHazardousMaterialsSafetyAdministrationPHMSA]: "U.S. Pipeline & Hazardous Materials Safety Administration (PHMSA)",
  [LegalSkill.UtilityLocalRegulatory]: "Utility - Local Regulatory",
  [LegalSkill.UtilityStateRegulatory]: "Utility - State Regulatory",
  [LegalSkill.USCaliforniaPublicUtilitiesCommissionCPUC]: "U.S. California Public Utilities Commission (CPUC)",
  [LegalSkill.USCommodityFuturesTradingCommissionCFTC]: "U.S. Commodity Futures Trading Commission (CFTC)",
  [LegalSkill.CommercialAndIndustrialCAndI]: "Commercial & Industrial (C&I)",
  [LegalSkill.DistributedGenerationCommunityAndRooftopSolar]: "Distributed Generation (Community & Rooftop Solar)",
  [LegalSkill.DistributedGenerationElectricVehicleChargers]: "Distributed Generation (Electric Vehicle Chargers)",
  [LegalSkill.UtilityScale]: "Utility Scale",
  [LegalSkill.PowerPurchaseAgreementsPPAs]: "Power Purchase Agreements (PPAs)",
  [LegalSkill.UtilityRateCasesAndTariffFilings]: "Utility Rate Cases & Tariff Filings",
  [LegalSkill.GridInterconnectionAndTransmissionAgreements]: "Grid Interconnection & Transmission Agreements",
  [LegalSkill.EnergyTradingAndCommodityTransactions]: "Energy Trading & Commodity Transactions",
  [LegalSkill.LandRightsAndEasementAcquisition]: "Land Rights & Easement Acquisition",
  [LegalSkill.EnergyStorageAndBatteryProjects]: "Energy Storage & Battery Projects",
  [LegalSkill.GridModernizationAndSmartGridDevelopment]: "Grid Modernization & Smart Grid Development",
  [LegalSkill.ElectricVehicleInfrastructureDevelopment]: "Electric Vehicle (EV) Infrastructure Development",
  [LegalSkill.JointOperatingAgreements]: "Joint Operating Agreements",
  [LegalSkill.ElectronicServiceAgreements]: "Electric Service Agreements",
  [LegalSkill.FederalEnergyRegulatoryCommissionFERCCompliance]: "Federal Energy Regulatory Commission (FERC) Compliance",
  [LegalSkill.StatePublicUtilityCommissionProceedings]: "State Public Utility Commission Proceedings",
  [LegalSkill.NorthAmericanElectricReliabilityCorporationNERCStandards]: "North American Electric Reliability Corporation (NERC) Standards",
  [LegalSkill.CaliforniaPublicUtilitiesCommission]: "California Public Utilities Commission (CPUC)",
  [LegalSkill.ContractDraftingNegotiationAndReview]: "Contract Drafting, Negotiation & Review",
  [LegalSkill.ContractLifecycleManagement]: "Contracts & Document Management",
  [LegalSkill.PoliciesAndProceduresDevelopment]: "Policies & Procedures Development",
  [LegalSkill.BidStrategyAdviceAndCounsel]: "Bid Strategy Advice & Counsel",
  [LegalSkill.RFPReviewAndRiskAssessments]: "RFP Review & Risk Assessments",
  [LegalSkill.PostAwardContractAdministration]: "Post Award Contract Administration",
  [LegalSkill.ProcurementAndBidManagement]: "Procurement & Bid Management",
  [LegalSkill.NationalAndFederalGovernment]: "Federal Government",
  [LegalSkill.LocalGovernment]: "Local Government",
  [LegalSkill.StateAndProvincialGovernment]: "State Government",
  [LegalSkill.FederalAcquisitionRegulationFARCompliance]: "Federal Acquisition Regulation (FAR) Compliance",
  [LegalSkill.DefenseFederalAcquisitionRegulationSupplement]: "Defense Federal Acquisition Regulation Supplement (DFARS) Compliance",
  [LegalSkill.SmallBusinessAdministrationSBARegulations]: "Small Business Administration (SBA) Regulations & Set-Asides",
  [LegalSkill.CostAccountingStandardsCASCompliance]: "Cost Accounting Standards (CAS) Compliance",
  [LegalSkill.TruthInNegotiationsActTINE]: "Truth in Negotiations Act (TINA) & Certified Cost or Pricing Data",
  [LegalSkill.BuyAmericanAct]: "Buy American Act & Trade Agreements Act Compliance",
  [LegalSkill.ServiceContractLaborStandardsSCLS]: "Service Contract Labor Standards (SCLS) & Davis-Bacon Act",
  [LegalSkill.FederalInformationSecurityManagementActFISMA]: "Federal Information Security Management Act (FISMA) & Cybersecurity Requirements",
  [LegalSkill.ExportAdministrationRegulationsEARITAR]: "Export Administration Regulations (EAR) & International Traffic in Arms Regulations (ITAR)",
  [LegalSkill.GovernmentEthicsAndOrganizationalConflictsOfInterest]: "Government Ethics & Organizational Conflicts of Interest (OCI)",
  [LegalSkill.ContractDisputesActAndClaimsProcedures]: "Contract Disputes Act & Claims Procedures",
  [LegalSkill.FreedomOfInformationActFOIA]: "Freedom of Information Act (FOIA) & Government Transparency Requirements",
  [LegalSkill.BoardMeetingMinutesAndAdministration]: "Board Meeting Minutes & Administration",
  [LegalSkill.BylawsAndCorporateGovernanceDocuments]: "Bylaws & Corporate Governance Documents",
  [LegalSkill.CompanyFilingCompliance]: "Company Filing Compliance",
  [LegalSkill.CorporateDiligenceAndReporting]: "Corporate Diligence & Reporting",
  [LegalSkill.ISOComplianceAndCorporateStandards]: "ISO Compliance & Corporate Standards",
  [LegalSkill.SubsidiaryManagement]: "Subsidiary Management",
  [LegalSkill.QuarterlyAndAnnualReports]: "Quarterly & Annual Reports",
  [LegalSkill.EntityManagementAndCompliance]: "Entity Management & Compliance",
  [LegalSkill.USReportingForms10K10QS1S4And8K]: "U.S. Reporting (Forms 10-K, 10-Q, S-1, S-4, 8-K)",
  [LegalSkill.UKPeriodicReportingUKCompaniesActAndUKListingRules]: "U.K. Periodic Reporting (U.K. Companies Act & U.K. Listing Rules)",
  [LegalSkill.CanadianDisclosureRequirements]: "Canadian Disclosure Requirements",
  [LegalSkill.AsianStockExchangeReporting]: "Asian Stock Exchange Reporting",
  [LegalSkill.EuropeanCompliance]: "European Compliance",
  [LegalSkill.AustralianCompliance]: "Australian Compliance",
  [LegalSkill.ProxyStatementsAndReports]: "Proxy Statements & Reports",
  [LegalSkill.RegulatoryAndStockExchangeCompliance]: "Regulatory & Stock Exchange Compliance",
  [LegalSkill.AIPrograms]: "AI Programs",
  [LegalSkill.DataMappingAndInventory]: "Data Mapping & Inventory",
  [LegalSkill.DataPrivacyImpactAssessmentDPIAPIA]: "Data Privacy Impact Assessment (DPIA / PIA)",
  [LegalSkill.DataSubjectAccessRequestsDSARs]: "Data Subject Access Requests (DSARs)",
  [LegalSkill.EmployeeTraining]: "Employee Training",
  [LegalSkill.GeneralPrivacyAdviceAndCounsel]: "General Privacy Advice & Counsel",
  [LegalSkill.PrivacyAgreementTemplatePreparation]: "Privacy Agreement Template Preparation",
  [LegalSkill.PrivacyAndCybersecurityIncidentResponse]: "Privacy & Cybersecurity Incident Response",
  [LegalSkill.PrivacyByDesignPrivacyByDefault]: "Privacy by Design, Privacy by Default",
  [LegalSkill.PrivacyGapAssessment]: "Privacy Gap Assessment",
  [LegalSkill.PrivacyPlaybookDevelopment]: "Privacy Playbook Development",
  [LegalSkill.PrivacyProgramDevelopment]: "Privacy Program Development",
  [LegalSkill.WebsitePrivacyPoliciesAndTermsOfUse]: "Website Privacy Policies & Terms of Use",
  [LegalSkill.DataProcessingAgreementDPAs]: "Data Processing Agreement (DPAs)",
  [LegalSkill.DataLicensingAndAcquisitionAgreements]: "Data Licensing & Acquisition Agreements",
  [LegalSkill.PrivacyClauseDraftingAndNegotiation]: "Privacy Clause Drafting & Negotiation",
  [LegalSkill.StandardContractualClausesSCCs]: "Standard Contractual Clauses (SCCs)",
  [LegalSkill.AILawsGlobal]: "A.I. Laws (Global)",
  [LegalSkill.AsiaPrivacyRegulationsPIPLAndOtherNonEnglish]: "Asia Privacy Regulations (PIPL & Other Non-English)",
  [LegalSkill.AustralianPrivacyLaws]: "Australian Privacy Laws",
  [LegalSkill.BrazilLeiGeralDeProtecaoDeDadosPessoaisLGPD]: "Brazil Lei Geral de Proteção de Dados Pessoais (LGPD)",
  [LegalSkill.CanadaPIPEDA]: "Canada PIPEDA",
  [LegalSkill.ChinaPIPLAndDataLocalization]: "China PIPL & Data Localization",
  [LegalSkill.EUAIAct]: "E.U. A.I. Act",
  [LegalSkill.EUEPrivacyDirective]: "E.U. E-Privacy Directive",
  [LegalSkill.EUGeneralDataProtectionRegulationGDPR]: "E.U. General Data Protection Regulation (GDPR)",
  [LegalSkill.EuropeanPrivacyLaws]: "European Privacy Laws",
  [LegalSkill.HongKongPrivacyLaw]: "Hong Kong Privacy Law",
  [LegalSkill.IndiaPrivacyRegulations]: "India Privacy Regulations",
  [LegalSkill.SingaporeanPrivacyLawsPDPA]: "Singaporean Privacy Laws (PDPA)",
  [LegalSkill.UKPrivacyLaws]: "U.K. Privacy Laws",
  [LegalSkill.EUUSDataPrivacyFrameworkDPF]: "EU-U.S. Data Privacy Framework (DPF)",
  [LegalSkill.USChildrensPrivacyRegulationsCOPPAAndStateLaws]: "U.S. Children's Privacy Regulations (COPPA & State Laws)",
  [LegalSkill.USFinancialPrivacyGrammLeachBlileyActGLBAAndSECPrivacyRegulations]: "U.S. Financial Privacy (Gramm-Leach-Bliley Act GLBA & SEC Privacy Regulations)",
  [LegalSkill.USHealthInsurancePortabilityAndAccountabilityActHIPAAAndStateHealthPrivacyLaws]: "U.S. Health Insurance Portability and Accountability Act (HIPAA) & State Health Privacy Laws",
  [LegalSkill.USWebContentAccessibilityGuidelinesWCAG]: "U.S. Web Content Accessibility Guidelines (WCAG)",
  [LegalSkill.USStatePrivacyLawsIncludingCCPACPRA]: "U.S. State Privacy Laws (including CCPA / CPRA)",
  [LegalSkill.USBiometricsLaws]: "U.S. Biometrics Laws",
  [LegalSkill.MiddleEastPrivacyLaws]: "Middle East Privacy Laws",
  [LegalSkill.AgreementDraftingAndNegotiation]: "Agreement Drafting & Negotiation",
  [LegalSkill.IncidentResponsePoliciesAndProcedures]: "Incident Response Policies & Procedures",
  [LegalSkill.IncidentResponseSupportIncludingNotifications]: "Incident Response Support (including Notifications)",
  [LegalSkill.SecuritybyDesign]: "Security by Design",
  [LegalSkill.AssetBasedLending]: "Asset-Based Lending",
  [LegalSkill.AviationFinance]: "Aviation Finance",
  [LegalSkill.EquipmentFinance]: "Equipment Finance",
  [LegalSkill.MarineAndMaritimeFinance]: "Marine & Maritime Finance",
  [LegalSkill.SupplyChainFinance]: "Supply Chain Finance",
  [LegalSkill.TransportationFinance]: "Transportation Finance",
  [LegalSkill.VendorFinance]: "Vendor Finance",
  [LegalSkill.B2BPaymentProducts]: "B2B Payment Products",
  [LegalSkill.CardsAndPrepaidCards]: "Cards & Prepaid Cards",
  [LegalSkill.DigitalAndMobileBanking]: "Digital & Mobile Banking",
  [LegalSkill.ElectronicFundsTransfersEFTs]: "Electronic Funds Transfers (EFTs)",
  [LegalSkill.MobileWallets]: "Mobile Wallets",
  [LegalSkill.Peer2PeerPaymentProductsP2P]: "Peer-2-Peer Payment Products (P2P)",
  [LegalSkill.CentralBankDigitalCurrenciesCBDCs]: "Central Bank Digital Currencies (CBDCs)",
  [LegalSkill.Cryptocurrency]: "Cryptocurrency (including Stablecoins)",
  [LegalSkill.InitialCoinOfferingsICOs]: "Initial Coin Offerings (ICOs)",
  [LegalSkill.TradingPlatforms]: "Digital Asset Trading Platforms",
  [LegalSkill.ConsumerBankingProducts]: "Consumer Banking Products",
  [LegalSkill.BuyNowPayLAterBNPLServices]: "Buy Now, Pay Later (BNPL) Services",
  [LegalSkill.CrossBorderPaymentSolutions]: "Cross-Border Payment Solutions",
  [LegalSkill.EUPaymentServicesDirectivePSD]: "E.U. Payment Services Directive (PSD)",
  [LegalSkill.USElectronicFundsTransferActEFTA]: "U.S. Electronic Funds Transfer Act (EFTA)",
  [LegalSkill.RegulationE]: "U.S. Regulation E",
  [LegalSkill.AsianPaymentLaws]: "Asian Payment Laws",
  [LegalSkill.AustralianPaymentLaws]: "Australian Payment Laws",
  [LegalSkill.EuropeanPaymentLaws]: "European Payment Laws",
  [LegalSkill.CanadianPaymentLaws]: "Canadian Payment Laws",
  [LegalSkill.USPaymentLaws]: "U.S. Payment Laws",
  [LegalSkill.PaymentCardIndustryDataSecurityStandardPCIDSS]: "Payment Card Industry Data Security Standard (PCI DSS)",
  [LegalSkill.LimitedResourceFinancing]: "Limited Resource Financing",
  [LegalSkill.PrivateProjectFinance]: "Private Project Finance",
  [LegalSkill.ProjectBonds]: "Project Bonds",
  [LegalSkill.PublicProjectFinance]: "Public Project Finance",
  [LegalSkill.BuildOperateTransferBOT]: "Build Operate Transfer (BOT)",
  [LegalSkill.EnergyProjectsWindSolarHydroPowerPlants]: "Energy Projects (Wind, Solar, Hydro, Power Plants)",
  [LegalSkill.EnvironmentalProjectFinance]: "Environmental Projects",
  [LegalSkill.InfrastructureAndTransportationProjects]: "Infrastructure & Transportation Projects",
  [LegalSkill.IslamicProjectFinance]: "Islamic Project Finance",
  [LegalSkill.TourismAndHospitality]: "Tourism & Hospitality",
  [LegalSkill.DerivativesAdviceAndCounsel]: "Derivatives Advice & Counsel",
  [LegalSkill.SecuritizationAdviceAndCounsel]: "Securitization Advice & Counsel",
  [LegalSkill.ProjectFinance]: "Project Finance",
  [LegalSkill.AssetBackedSecuritiesABS]: "Asset-Backed Securities (ABS)",
  [LegalSkill.CollateralizedDebtObligationsCDOs]: "Collateralized Debt Obligations (CDOs)",
  [LegalSkill.CollateralizedLoanObligationsCLOs]: "Collateralized Loan Obligations (CLOs)",
  [LegalSkill.CommercialMortgageBackedSecuritiesCMBS]: "Commercial Mortgage-Backed Securities (CMBS)",
  [LegalSkill.MortgageBackedSecuritiesMBS]: "Mortgage-Backed Securities (MBS)",
  [LegalSkill.LandAndPropertyAgreementRefinancing]: "Land & Property Agreement Refinancing",
  [LegalSkill.LendingDueDiligence]: "Lending Due Diligence",
  [LegalSkill.LoanDocumentationAndDueDiligence]: "Loan Documentation",
  [LegalSkill.LoanStructuringAndOrigination]: "Loan Structuring & Origination",
  [LegalSkill.WorkOutsNoteSalesAndForeclosures]: "Work Outs, Note Sales & Foreclosures",
  [LegalSkill.ConstructionFinancing]: "Construction Financing",
  [LegalSkill.HousingAndUrbanDevelopmentHUDExpertise]: "Housing & Urban Development (HUD) Expertise",
  [LegalSkill.ExportControls]: "Export Controls",
  [LegalSkill.ExportCreditInsurance]: "Export Credit Insurance",
  [LegalSkill.ExportWorkingCapitalLoans]: "Export Working Capital Loans",
  [LegalSkill.ImportControls]: "Import Controls",
  [LegalSkill.LettersOfCredit]: "Letters of Credit",
  [LegalSkill.PreExportFinancing]: "Pre-Export Financing",
  [LegalSkill.RevolvingCreditFacilities]: "Revolving Credit Facilities",
  [LegalSkill.Sanctions]: "Sanctions Legal Counsel",
  [LegalSkill.ECCNClassificationAndResearch]: "Export Control Classification Number (ECCN) Classification & Research",
  [LegalSkill.BiLateralLoanAgreements]: "Bi-Lateral Loan Agreements",
  [LegalSkill.CreditFacilitiesRevolvingCreditTermLoansLetterOfCredit]: "Credit Facilities (Revolving Credit, Term Loans, Letter of Credit)",
  [LegalSkill.LettersOfCredit_Activities]: "Letters of Credit",
  [LegalSkill.RepurchaseAgreementsRepoAgreements]: "Repurchase Agreements (Repo Agreements)",
  [LegalSkill.SyndicatedLoans]: "Syndicated Loans",
  [LegalSkill.AutoLoanProductsAndServices]: "Auto Loan Products & Services",
  [LegalSkill.ConsumerDepositProducts]: "Consumer Deposit Products",
  [LegalSkill.LoanWorkouts]: "Loan Workouts",
  [LegalSkill.Mortgages]: "Mortgages & Home Equity Loans",
  [LegalSkill.RetailBankingProductsAndServices]: "Retail Banking Products & Services",
  [LegalSkill.StudentLoanProductsAndServices]: "Student Loan Products & Services",
  [LegalSkill.DebtColectionAndRecovery]: "Debt Collection & Recovery",
  [LegalSkill.UnsecuredConsumerLoans]: "Unsecured Consumer Loans",
  [LegalSkill.ConsumerCards]: "Consumer Cards",
  [LegalSkill.USConsumerFinancialProtectionBureauCFPB]: "U.S. Consumer Financial Protection Bureau (CFPB)",
  [LegalSkill.AsianConsumerBankingLaws]: "Asian Consumer Banking Laws",
  [LegalSkill.AustralianConsumerBankingLaws]: "Australian Consumer Banking Laws",
  [LegalSkill.CanadianConsumerBankingLaws]: "Canadian Consumer Banking Laws",
  [LegalSkill.EuropeanConsumerBankingLaws]: "European Consumer Banking Laws",
  [LegalSkill.UKConsumerBankingLaws]: "U.K. Consumer Banking Laws",
  [LegalSkill.USCommunityReinvestmentActCRA]: "U.S. Community Reinvestment Act (CRA)",
  [LegalSkill.RetailBankingMarketingReview]: "Retail Banking Marketing Review",
  [LegalSkill.RetailBankingRegulatoryCompliance]: "Retail Banking Regulatory Compliance",
  [LegalSkill.CorporateTrusteeAdvisory]: "Corporate Trustee Advisory",
  [LegalSkill.DebtIssuance]: "Debt Issuance",
  [LegalSkill.EscrowServices]: "Escrow Services",
  [LegalSkill.TrustEstablishmentAndAdministration]: "Trust Establishment & Administration",
  [LegalSkill.TrustInstrumentsStructuringAndDrafting]: "Trust Instruments Structuring & Drafting",
  [LegalSkill.TrusteeDutiesAndResponsibilities]: "Trustee Duties & Responsibilities",
  [LegalSkill.EmployeeBenefitTrusts]: "Employee Benefit Trusts",
  [LegalSkill.SecuritizationTrusts]: "Securitization Trusts",
  [LegalSkill.USPrudentInvestorRule]: "U.S. Prudent Investor Rule",
  [LegalSkill.USTrustIndentureActOf1939TIA]: "U.S. Trust Indenture Act of 1939 (TIA)",
  [LegalSkill.USUniformTrustCodeUTC]: "U.S. Uniform Trust Code (UTC)",
  [LegalSkill.EuropeanRegulatoryAdvisory_RegulatoryExpertise_CorporateTrustsLendingAndBorrowing]: "European Regulatory Advisory",
  [LegalSkill.CanadianRegulatoryAdvisory_RegulatoryExpertise_CorporateTrustsLendingAndBorrowing]: "Canadian Regulatory Advisory",
  [LegalSkill.AsianRegulatoryAdvisory_RegulatoryExpertise_CorporateTrustsLendingAndBorrowing]: "Asian Regulatory Advisory",
  [LegalSkill.AustralianRegulatoryAdvisory_RegulatoryExpertise_CorporateTrustsLendingAndBorrowing]: "Australian Regulatory Advisory",
  [LegalSkill.UKRegulatoryAdvisory_RegulatoryExpertise_CorporateTrustsLendingAndBorrowing]: "U.K. Regulatory Advisory",
  [LegalSkill.ClearingAgreements]: "Clearing Agreements",
  [LegalSkill.CreditSupportAnnex]: "Credit Support Annex",
  [LegalSkill.CustodialAgreements]: "Custodial Agreements",
  [LegalSkill.GMRAsAndMRAsDraftingAndExecution]: "GMRA & MRA Drafting & Execution",
  [LegalSkill.ISDANegotiation]: "ISDA Negotiation",
  [LegalSkill.MSFTADraftingAndExecution]: "MSFTA Drafting & Execution",
  [LegalSkill.NettingAgreementsAndOpinions]: "Netting Agreements & Opinions",
  [LegalSkill.CommoditiesDerivatives]: "Commodities Derivatives",
  [LegalSkill.Futures]: "Futures Legal Counsel",
  [LegalSkill.Options]: "Options Legal Counsel",
  [LegalSkill.OTCDerivatives]: "OTC Derivatives",
  [LegalSkill.SWAPS]: "SWAPS Legal Counsel",
  [LegalSkill.USMarginReform]: "U.S. Margin Reform",
  [LegalSkill.USRule4210RegulatoryCompliance]: "U.S. Rule 4210 Regulatory Compliance",
  [LegalSkill.USRegulatoryAdvisory_RegulatoryExpertise]: "U.S. Regulatory Advisory",
  [LegalSkill.AsianRegulatoryAdvisory_RegulatoryExpertise_Derivatives]: "Asian Regulatory Advisory",
  [LegalSkill.AustralianRegulatoryAdvisory_RegulatoryExpertise_Derivatives]: "Australian Regulatory Advisory",
  [LegalSkill.CanadianRegulatoryAdvisory_RegulatoryExpertise_Derivatives]: "Canadian Regulatory Advisory",
  [LegalSkill.EuropeanRegulatoryAdvisory_RegulatoryExpertise_Derivatives]: "European Regulatory Advisory",
  [LegalSkill.UKRegulatoryAdvisory_RegulatoryExpertise_Derivatives]: "U.K. Regulatory Advisory",
  [LegalSkill.SideLetters_Activities_SecuritiesAndPrimeBrokerage]: "Side Letters",
  [LegalSkill.SECMarketingMaterialReview]: "SEC Marketing Material Review (2021 Rule)",
  [LegalSkill.FortyActFilings]: "40 Act Filings",
  [LegalSkill.EntityFormationLLCsAndLPAs]: "Entity Formation (LLCs & LPAs)",
  [LegalSkill.FormPF]: "Form PF",
  [LegalSkill.FundFormation]: "Fund Formation",
  [LegalSkill.InvestorRelations]: "Investor Relations",
  [LegalSkill.OfferingMemoranda]: "Offering Memoranda",
  [LegalSkill.PrivatePlacementMemorandum_FundActivities]: "Private Placement Memorandum",
  [LegalSkill.ProspectusAndRegulatoryFilings]: "Prospectus & Regulatory Filings",
  [LegalSkill.SubscriptionAgreements_FundActivities]: "Subscription Agreements",
  [LegalSkill.AngelSeedOrVentureCapitalFunds]: "Angel, Seed &Venture Capital Funds",
  [LegalSkill.ExchangeTradedFundsETFs]: "Exchange Traded Funds (ETFs)",
  [LegalSkill.FundOfFunds]: "Fund of Funds",
  [LegalSkill.HedgeFunds]: "Hedge Funds",
  [LegalSkill.MutualFunds]: "Mutual Funds",
  [LegalSkill.PrivateEquityFunds]: "Private Equity Funds",
  [LegalSkill.PrivateFunds]: "Private Funds",
  [LegalSkill.PublicFunds]: "Public Funds",
  [LegalSkill.PublicPensionFunds]: "Public Pension Funds",
  [LegalSkill.PortfolioManagement]: "Portfolio Management",
  [LegalSkill.PrimeBrokerageEquities]: "Prime Brokerage (Equities)",
  [LegalSkill.PrimeBrokerageFixedIncome]: "Prime Brokerage (Fixed Income)",
  [LegalSkill.BrokerDealer]: "Broker-Dealer",
  [LegalSkill.InvestmentAdvisors]: "Investment Advisors",
  [LegalSkill.USExchangeActOf1934Compliance_RegulatoryExpertise_InvestmentAndWealthManagement]: "U.S. Exchange Act of 1934 Compliance",
  [LegalSkill.USInvestmentAdvisersActOf1940]: "U.S. Investment Advisers Act of 1940",
  [LegalSkill.AustralianRegulatoryAdvisory_RegulatoryExpertise_InvestmentAndWealthManagement]: "Australian Regulatory Advisory",
  [LegalSkill.AsianRegulatoryAdvisory_RegulatoryExpertise_InvestmentAndWealthManagement]: "Asian Regulatory Advisory",
  [LegalSkill.CanadianRegulatoryAdvisory_RegulatoryExpertise_InvestmentAndWealthManagement]: "Canadian Regulatory Advisory",
  [LegalSkill.EuropeanRegulatoryAdvisory_RegulatoryExpertise_InvestmentAndWealthManagement]: "European Regulatory Advisory",
  [LegalSkill.UKRegulatoryAdvisory_RegulatoryExpertise_InvestmentAndWealthManagement]: "U.K. Regulatory Advisory",
  [LegalSkill.RegulatoryExaminationsAndComplianceAudits]: "Regulatory Examinations & Compliance Audits",
  [LegalSkill.MergersAcquisitionsAndCorporateTransactions]: "Mergers, Acquisitions & Corporate Transactions",
  [LegalSkill.InsuranceLitigationSupport]: "Insurance Litigation Support",
  [LegalSkill.PolicyFormDevelopmentAndFiling]: "Policy Form Development & Filing",
  [LegalSkill.AgentAndBrokerLicensing]: "Agent & Broker Licensing",
  [LegalSkill.ClaimsManagement]: "Claims Management & Coverage Disputes",
  [LegalSkill.InsuranceProductAdvisory]: "Insurance Product Advisory",
  [LegalSkill.OpinionLetters]: "Opinion Letters",
  [LegalSkill.ReinsuranceAgreements]: "Reinsurance Agreements",
  [LegalSkill.RiskManagementProgramDevelopment]: "Risk Management Program Development",
  [LegalSkill.COIManagement]: "Certificate of Insurance (COI) Management",
  [LegalSkill.IPInfringementInsurance]: "IP Infringement Insurance",
  [LegalSkill.LifeInsuranceAndAnnuityProducts]: "Life Insurance & Annuity Products",
  [LegalSkill.MutualInsuranceAndMutualInsurer]: "Mutual Insurance & Mutual Insurer",
  [LegalSkill.PropertyAndCasualtyProducts]: "Property & Casualty Products",
  [LegalSkill.WorkersCompensationInsurance]: "Workers' Compensation Insurance",
  [LegalSkill.CyberAndTechnologyInsurance]: "Cyber & Technology Insurance",
  [LegalSkill.DirectorsAndOfficersInsurance]: "Directors & Officers (D&O) Insurance",
  [LegalSkill.ProfessionalLiabilityInsurance]: "Professional Liability Insurance",
  [LegalSkill.HealthInsuranceProducts]: "Health Insurance & Managed Care Products",
  [LegalSkill.MedicareAdvantagePlans]: "Medicare Advantage Plans",
  [LegalSkill.MedicaidManagedCare]: "Medicaid Managed Care",
  [LegalSkill.USStateInsuranceCompliance]: "U.S. State Insurance Compliance",
  [LegalSkill.BaselIIIBankForInternationalSettlements]: "Basel III (Bank for International Settlements)",
  [LegalSkill.EUSolvencyIIRegulations]: "E.U. Solvency II Regulations",
  [LegalSkill.InsuranceMarketEntryAndExitRequirements]: "Insurance Market Entry & Exit Requirements",
  [LegalSkill.InsurerLicensingAndAuthorization]: "Insurer Licensing & Authorization",
  [LegalSkill.InternationalAssociationOfInsuranceSupervisorsIAIS]: "International Association of Insurance Supervisors (IAIS)",
  [LegalSkill.USNationalAssociationOfInsuranceCommissionersNAIC]: "U.S. National Association of Insurance Commissioners (NAIC)",
  [LegalSkill.AsianRegulatoryAdvisory_RegulatoryExpertise_Insurance]: "Asian Regulatory Advisory",
  [LegalSkill.AustralianRegulatoryAdvisory_RegulatoryExpertise_Insurance]: "Australian Regulatory Advisory",
  [LegalSkill.EuropeanRegulatoryAdvisory_RegulatoryExpertise_Insurance]: "European Regulatory Advisory",
  [LegalSkill.CanadianRegulatoryAdvisory_RegulatoryExpertise_Insurance]: "Canadian Regulatory Advisory",
  [LegalSkill.FiftyStateSurveys]: "50 State Surveys",
  [LegalSkill.UKRegulatoryAdvisory_RegulatoryExpertise_Insurance]: "U.K. Regulatory Advisory",
  [LegalSkill.DiscoveryAndDocumentReviewAndManagement]: "Discovery, Document Review & Management",
  [LegalSkill.LegalResearchAndWriting]: "Legal Research & Writing",
  [LegalSkill.AnalyticsAndReporting]: "Analytics & Reporting",
  [LegalSkill.ContractLifecycleManagementCLMImplementation]: "Contract Lifecycle Management (CLM) Implementation",
  [LegalSkill.ContractLifecycleManagementCLMProgramManagementAndMaintenance]: "Contract Lifecycle Management (CLM) Program Management & Maintenance",
  [LegalSkill.CostReductionAndBudgeting]: "Cost Reduction & Budgeting",
  [LegalSkill.EBilling]: "E-Billing",
  [LegalSkill.OutsideCounselManagement]: "Outside Counsel Management",
  [LegalSkill.ProcessManagementAndNewProcessMapping]: "Process Management & New Process Mapping",
  [LegalSkill.ProjectManagement]: "Project Management",
  [LegalSkill.ProgramManagement]: "Program Management",
  [LegalSkill.ProcessImprovementAndOptimization]: "Process Improvement & Optimization",
  [LegalSkill.RiskTracking]: "Risk Tracking",
  [LegalSkill.TemplatesPlaybooksAndOptimizations]: "Templates, Playbooks & Optimizations",
  [LegalSkill.ADRStrategy]: "ADR Strategy",
  [LegalSkill.DiscoveryDocumentReviewAndManagement]: "Discovery, Document Review & Management",
  [LegalSkill.OutsideCounselManagement_Activities]: "Outside Counsel Management",
  [LegalSkill.PleadingsMotionsAndDepositions]: "Pleadings, Motions & Depositions",
  [LegalSkill.PreSuitInvestigationAndPreparation]: "Pre-Suit Investigation & Preparation",
  [LegalSkill.AutoWarrantyAndLemonLaw]: "Auto Warranty & Lemon Law",
  [LegalSkill.BreachOfContractLaw]: "Breach of Contract & Commercial Disputes",
  [LegalSkill.ConstructionLaw]: "Construction",
  [LegalSkill.ConsumerDisputes]: "Consumer Disputes",
  [LegalSkill.EmploymentLaw]: "Employment",
  [LegalSkill.EnvironmentalLaw]: "Environmental",
  [LegalSkill.FinancialLaw]: "Banking & Financial Services",
  [LegalSkill.GeneralLiability]: "General Liability",
  [LegalSkill.InsuranceCoverageDisputes]: "Insurance Coverage Disputes",
  [LegalSkill.IPLaw]: "Intellectual Property",
  [LegalSkill.PersonalInjuryLaw]: "Personal Injury",
  [LegalSkill.PremisesLiability]: "Premises Liability",
  [LegalSkill.ProductLiability]: "Product Liability",
  [LegalSkill.ProfessionalLiabilityLaw]: "Professional Liability",
  [LegalSkill.RealEstateLaw]: "Real Estate",
  [LegalSkill.Appeals_Activities_Litigation]: "Appeals",
  [LegalSkill.DiscoveryAndDocumentReviewAndManagement_Activities_Litigation]: "Discovery, Document Review & Management",
  [LegalSkill.LitigationAdviceAndCounsel_Activities_Litigation]: "Litigation Advice & Counsel",
  [LegalSkill.HighVolumeLitigation_Activities_Litigation]: "High Volume Litigation",
  [LegalSkill.ClassActions_Activities_Litigation]: "Class Actions",
  [LegalSkill.ArbitrationMediationADR_Activities_Litigation]: "Arbitration, Mediation & ADR",
  [LegalSkill.OutsideCounselManagement_Activities_Litigation]: "Outside Counsel Management",
  [LegalSkill.PleadingsMotionsAndDepositions_Activities_Litigation]: "Pleadings, Motions & Depositions",
  [LegalSkill.PreSuitInvestigationAndPreparation_Activities_Litigation]: "Pre-Suit Investigation & Preparation",
  [LegalSkill.TrialPreparationAndSupport_Activities_Litigation]: "Trial Preparation & Support",
  [LegalSkill.DocketManagement_Activities_Litigation]: "Docket Management",
  [LegalSkill.BudgetManagement_Activities_Litigation]: "Budget Management",
  [LegalSkill.Antitrust_TypesOfDisputes_Litigation]: "Antitrust",
  [LegalSkill.AutoWarrantyAndLemonLaw_TypesOfDisputes_Litigation]: "Auto Warranty & Lemon Law",
  [LegalSkill.BankingAndFinancialServices_TypesOfDisputes_Litigation]: "Banking & Financial Services",
  [LegalSkill.BreachOfContract_TypesOfDisputes_Litigation]: "Breach of Contract",
  [LegalSkill.ClassAction_TypesOfDisputes_Litigation]: "Class Action",
  [LegalSkill.Construction_TypesOfDisputes_Litigation]: "Construction",
  [LegalSkill.CommercialDisputes_TypesOfDisputes_Litigation]: "Commercial Disputes",
  [LegalSkill.Employment_TypesOfDisputes_Litigation]: "Employment",
  [LegalSkill.Environmental_TypesOfDisputes_Litigation]: "Environmental",
  [LegalSkill.ConsumerDisputes_TypesOfDisputes_Litigation]: "Consumer Disputes",
  [LegalSkill.ConsumerFinance_TypesOfDisputes_Litigation]: "Consumer Finance",
  [LegalSkill.HighVolumeLitigation_TypesOfDisputes_Litigation]: "High Volume Litigation",
  [LegalSkill.InsuranceCoverageDisputes_TypesOfDisputes_Litigation]: "Insurance Coverage Disputes",
  [LegalSkill.IntellectualProperty_TypesOfDisputes_Litigation]: "Intellectual Property",
  [LegalSkill.GeneralLiability_TypesOfDisputes_Litigation]: "General Liability",
  [LegalSkill.PremisesLiability_TypesOfDisputes_Litigation]: "Premises Liability",
  [LegalSkill.ProductLiability_TypesOfDisputes_Litigation]: "Product Liability",
  [LegalSkill.ProfessionalLiability_TypesOfDisputes_Litigation]: "Professional Liability",
  [LegalSkill.RealEstate_TypesOfDisputes_Litigation]: "Real Estate",
  [LegalSkill.Securities_TypesOfDisputes_Litigation]: "Securities",
  [LegalSkill.WhiteCollarDisputes_TypesOfDisputes_Litigation]: "White Collar Disputes",
  [LegalSkill.Plaintiff_LitigationRole_Litigation]: "Plaintiff",
  [LegalSkill.Defendant_LitigationRole_Litigation]: "Defendant",
  [LegalSkill.AncillaryTransactionDocumentation]: "Ancillary Transaction Documentation",
  [LegalSkill.BuySideDefinitiveAgreementExecutionAndNegotiation]: "Buy-Side Definitive Agreement Execution & Negotiation",
  [LegalSkill.BuySideDueDiligence]: "Buy-Side Due Diligence",
  [LegalSkill.DocumentAndDataRoomManagement]: "Document & Data Room Management",
  [LegalSkill.DisclosureSchedules]: "Disclosure Schedules",
  [LegalSkill.FinancingAndRegulatoryApproval]: "Financing & Regulatory Approval",
  [LegalSkill.OfferingMemorAnda_Activities]: "Offering Memoranda",
  [LegalSkill.PostClosingAdviceAndCounsel]: "Post-Closing & Integration Advice & Counsel",
  [LegalSkill.PreDealStrategyLOIsAndTermSheets]: "Pre-Deal Strategy, LOIs & Term Sheets",
  [LegalSkill.PurchaseAgreements]: "Purchase Agreements",
  [LegalSkill.SellSideDefinitiveAgreementExecutionAndNegotiation]: "Sell-Side Definitive Agreement Execution & Negotiation",
  [LegalSkill.SellSideDueDiligence]: "Sell-Side Due Diligence",
  [LegalSkill.RepAndWarrantyInsuranceTermsNegotiation]: "Rep & Warranty Insurance Terms Negotiation",
  [LegalSkill.RedFlagMemoDrafting]: "Red Flag Memo Drafting",
  [LegalSkill.ShareholderAgreements]: "Shareholder Agreements",
  [LegalSkill.CorporateAndInvestmentPortfolioMaintenance]: "Corporate & Investment Portfolio Maintenance",
  [LegalSkill.JointVentureDueDiligence]: "Joint Venture Due Diligence",
  [LegalSkill.AntitrustMAndAAdvisory]: "Antitrust M&A Advisory",
  [LegalSkill.DataPrivacyMAndAAdvisory]: "Data Privacy M&A Advisory",
  [LegalSkill.IntellectualPropertyMAndAAdvisory]: "Intellectual Property M&A Advisory",
  [LegalSkill.LaborAndEmploymentAndERISAMAndAAdvisory]: "Labor & Employment and ERISA M&A Advisory",
  [LegalSkill.PublicSecuritiesAndTransactionsMAndAAdvisory]: "Public Securities & Transactions M&A Advisory",
  [LegalSkill.TaxMAndAAdvisory]: "Tax M&A Advisory",
  [LegalSkill.Acquisition]: "Acquisition Legal Counsel",
  [LegalSkill.Divestiture]: "Divestiture Legal Counsel",
  [LegalSkill.Merger]: "Merger Legal Counsel",
  [LegalSkill.JointVenture]: "Joint Venture",
  [LegalSkill.ContractAndTitleReview]: "Contract & Title Review",
  [LegalSkill.LandAndPropertyAgreementsSaleOrPurchase]: "Land & Property Agreements Sale or Purchase",
  [LegalSkill.RealEstateLeasingAgreements]: "Real Estate Leasing Agreements",
  [LegalSkill.RealEstateLicensingAgreements]: "Real Estate Licensing Agreements",
  [LegalSkill.RealEstatePortfolioAuditAndManagement]: "Real Estate Portfolio Audit & Management",
  [LegalSkill.TitleObjectionLetters]: "Title Objection Letters",
  [LegalSkill.ConveyanceAndClosingDocumentation]: "Conveyance & Closing Documentation",
  [LegalSkill.UCCFinancingStatements]: "UCC Financing Statements",
  [LegalSkill.DevelopmentAgreementsandREAs]: "Development Agreements & REAs",
  [LegalSkill.TransactionManagementAndDueDiligence]: "Transaction Management & Due Diligence",
  [LegalSkill.EstoppelsAndSNDAs]: "Estoppels & SNDAs",
  [LegalSkill.RealEstateInvestigationsAndEnforcement]: "Real Estate Investigations & Enforcement",
  [LegalSkill.ConstructionContractsAIAContractsAndEPC]: "Construction Contract Negotiation & Management",
  [LegalSkill.ConstructionLiens]: "Construction Dispute Resolution & Lien Management",
  [LegalSkill.LandUseAndZoning]: "Land Use & Zoning Approvals",
  [LegalSkill.DevelopmentProjectAdvisory]: "Development Project Advisory",
  [LegalSkill.PublicPrivatePartnershipStructuring]: "Public-Private Partnership Structuring",
  [LegalSkill.EnvironmentalAndRegulatoryCompliance]: "Environmental & Regulatory Compliance",
  [LegalSkill.AntitrustDueDiligence]: "Antitrust Due Diligence",
  [LegalSkill.AntitrustLitigation_RegulatoryExpertise]: "Antitrust Litigation",
  [LegalSkill.AntitrustMergersAndAcquisitions]: "Antitrust Mergers & Acquisitions",
  [LegalSkill.USClaytonAntitrustAct1914]: "U.S. Clayton Antitrust Act (1914)",
  [LegalSkill.InvestigationManagement]: "Investigation Management",
  [LegalSkill.USShermanAntitrustAct1890]: "U.S. Sherman Antitrust Act (1890)",
  [LegalSkill.AsianRegulatoryAdvisory_RegulatoryExpertise_AntitrustAndCompetition]: "Asian Regulatory Advisory",
  [LegalSkill.AustralianRegulatoryAdvisory_RegulatoryExpertise_AntitrustAndCompetition]: "Australian Regulatory Advisory",
  [LegalSkill.CanadianRegulatoryAdvisory_RegulatoryExpertise_AntitrustAndCompetition]: "Canadian Regulatory Advisory",
  [LegalSkill.EuropeanRegulatoryAdvisory_RegulatoryExpertise_AntitrustAndCompetition]: "European Regulatory Advisory",
  [LegalSkill.UKRegulatoryAdvisory_RegulatoryExpertise_AntitrustAndCompetition]: "U.K. Regulatory Advisory",
  [LegalSkill.USFederalTradeCommissionActFTCA_RegulatoryExpertise_AntitrustAndCompetition]: "U.S. Federal Trade Commission Act (FTCA)",
  [LegalSkill.USHartScottRodinoAntitrustImprovementsAct]: "U.S. Hart-Scott-Rodino Antitrust Improvements Act (1976)",
  [LegalSkill.USRobinsonPatmanAct]: "U.S. Robinson-Patman Act",
  [LegalSkill.AntiBriberyComplianceProgramDevelopment]: "Anti-Bribery Compliance Program Development",
  [LegalSkill.EnforcementActions]: "Enforcement Actions",
  [LegalSkill.InternalInvestigationsManagement]: "Internal Investigations Management",
  [LegalSkill.ComplianceAndEthicsProgramsPoliciesAndProcedures]: "Compliance & Ethics Programs, Policies & Procedures",
  [LegalSkill.UKBriberyAct]: "U.K. Bribery Act",
  [LegalSkill.USForeignCorruptPracticesActFCPA]: "U.S. Foreign Corrupt Practices Act (FCPA)",
  [LegalSkill.USPatriotAct]: "U.S. Patriot Act",
  [LegalSkill.AsianRegulatoryAdvisory_RegulatoryExpertise_BriberyAndCorruption]: "Asian Regulatory Advisory",
  [LegalSkill.AustralianRegulatoryAdvisory_RegulatoryExpertise_BriberyAndCorruption]: "Australian Regulatory Advisory",
  [LegalSkill.CanadianRegulatoryAdvisory_RegulatoryExpertise_BriberyAndCorruption]: "Canadian Regulatory Advisory",
  [LegalSkill.EuropeanRegulatoryAdvisory_RegulatoryExpertise_BriberyAndCorruption]: "European Regulatory Advisory",
  [LegalSkill.USBriberyOfPublicOfficialsAndWitnesses]: "U.S. Bribery of Public Officials & Witnesses",
  [LegalSkill.USHobbsAct]: "U.S. Hobbs Act",
  [LegalSkill.USTravelAct]: "U.S. Travel Act",
  [LegalSkill.USProgramFraudCivilRemediesAct]: "U.S. Program Fraud Civil Remedies Act",
  [LegalSkill.USRICE]: "U.S. RICO",
  [LegalSkill.USAntiKickbackStatute_RegulatoryExpertise_BriberyAndCorruption]: "U.S. Anti-Kickback Statute",
  [LegalSkill.USBankBriberyAct]: "U.S. Bank Bribery Act",
  [LegalSkill.ConsumerProtectionComplianceProgramDevelopment]: "Compliance Program Development",
  [LegalSkill.UKConsumerProtectionfromUnfairTradingRegulationsCPUT]: "U.K. Consumer Protection from Unfair Trading Regulations (CPUT)",
  [LegalSkill.UKConsumerRightsAct]: "U.K. Consumer Rights Act",
  [LegalSkill.USDeceptiveAndAbusiveActsOrPracticesUDAAP]: "U.S. Deceptive and Abusive Acts or Practices (UDAAP)",
  [LegalSkill.USFairDebtCollectionPracticesActFDCPA]: "U.S. Fair Debt Collection Practices Act (FDCPA)",
  [LegalSkill.USFDA]: "U.S. FDA",
  [LegalSkill.USFederalTradeCommissionActFTCA]: "U.S. Federal Trade Commission Act (FTCA)",
  [LegalSkill.USTruthInLendingActTILA]: "U.S. Truth in Lending Act (TILA)",
  [LegalSkill.AsianRegulatoryAdvisory_RegulatoryExpertise_ConsumerProtectionRegulation]: "Asian Regulatory Advisory",
  [LegalSkill.AustralianRegulatoryAdvisory_RegulatoryExpertise_ConsumerProtectionRegulation]: "Australian Regulatory Advisory",
  [LegalSkill.CanadianRegulatoryAdvisory_RegulatoryExpertise_ConsumerProtectionRegulation]: "Canadian Regulatory Advisory",
  [LegalSkill.EuropeanRegulatoryAdvisory_RegulatoryExpertise_ConsumerProtectionRegulation]: "European Regulatory Advisory",
  [LegalSkill.USFairCreditReportingActFCRA]: "U.S. Fair Credit Reporting Act (FCRA)",
  [LegalSkill.RealEstateSettlementProceduresAct]: "U.S. Real Estate Settlement Procedures Act (RESPA)",
  [LegalSkill.DoddFrankWallStreetReform]: "U.S. Dodd-Frank Wall Street Reform & Consumer Protection Act",
  [LegalSkill.ConsumerProductSafetyAct]: "U.S. Consumer Product Safety Act",
  [LegalSkill.AsianRegulatoryAdvisory_RegulatoryExpertise_EnergyRegulationAndCompliance]: "Asian Regulatory Advisory",
  [LegalSkill.AustralianRegulatoryAdvisory_RegulatoryExpertise_EnergyRegulationAndCompliance]: "Australian Regulatory Advisory",
  [LegalSkill.CanadianRegulatoryAdvisory_RegulatoryExpertise_EnergyRegulationAndCompliance]: "Canadian Regulatory Advisory",
  [LegalSkill.EuropeanRegulatoryAdvisory_RegulatoryExpertise_EnergyRegulationAndCompliance]: "European Regulatory Advisory",
  [LegalSkill.OilAndGasAdvisory]: "Oil & Gas Advisory",
  [LegalSkill.RenewablePortfolioStandardsRPSAndEnergyEfficiencyStandards]: "Renewable Portfolio Standards (RPS) & Energy Efficiency Standards",
  [LegalSkill.UKElectricityAct1989]: "U.K. Electricity Act 1989",
  [LegalSkill.UKRenewablesObligationROAndFeedInTariffsFiTs]: "U.K. Renewables Obligation (RO) & Feed-in Tariffs (FiTs)",
  [LegalSkill.USCleanAirActCAA]: "U.S. Clean Air Act (CAA)",
  [LegalSkill.USEnergyPolicyActOf2005]: "U.S. Energy Policy Act of 2005",
  [LegalSkill.USFederalEnergyRegulatoryCommissionFERC]: "U.S. Federal Energy Regulatory Commission (FERC)",
  [LegalSkill.USPipelineAndHazardousMaterialsSafetyAdministrationPHMSA_RegulatoryExpertise]: "U.S. Pipeline & Hazardous Materials Safety Administration (PHMSA)",
  [LegalSkill.USPublicUtilityRegulatoryPoliciesActPURPA]: "U.S. Public Utility Regulatory Policies Act (PURPA)",
  [LegalSkill.DisclosureAndReporting]: "ESG Disclosure & Reporting",
  [LegalSkill.EnvironmentalImpactStatements]: "Environmental Impact Statements",
  [LegalSkill.PolicyDevelopmentAndImplementation_Activities]: "ESG Policy Development & Implementation",
  [LegalSkill.RiskAssessmentsAndInternalAudits]: "Risk Assessments & Internal Audits",
  [LegalSkill.CDPReporting]: "CDP Reporting",
  [LegalSkill.EnvironmentalComplianceAdviceAndCounsel]: "Environmental Compliance Advice & Counsel",
  [LegalSkill.SocialComplianceAdviceAndCounsel]: "Social Compliance Advice & Counsel",
  [LegalSkill.CorporateGovernanceAdviceAndCounsel]: "Corporate Governance Advice & Counsel",
  [LegalSkill.EAndCComplianceAdviceAndCounsel]: "E&C Compliance Advice & Counsel",
  [LegalSkill.EthicsAndComplianceProgramStrategyAndAssessment]: "Ethics & Compliance Program Stategy & Assessment",
  [LegalSkill.EnvironmentalEnforcementActions]: "Environmental Enforcement Actions",
  [LegalSkill.EnvironmentalLitigation]: "Environmental Litigation",
  [LegalSkill.EnvironmentalCleanups]: "Environmental Cleanups",
  [LegalSkill.EUCorporateSustainabilityReportingDirectiveCSRD]: "E.U. Corporate Sustainability Reporting Directive (CSRD)",
  [LegalSkill.EuropeanAccessibilityAct]: "European Accessibility Act",
  [LegalSkill.EUTaxonomyRegulation]: "E.U. Taxonomy Regulation",
  [LegalSkill.EuropeanGreenDeal]: "European Green Deal",
  [LegalSkill.OECDGuidelines]: "OECD Guidelines",
  [LegalSkill.UNGlobalCompactAndGuidingPrinciples]: "U.N. Global Compact & Guiding Principles",
  [LegalSkill.UKModernSlaveryAct]: "U.K. Modern Slavery Act",
  [LegalSkill.UKEnvironmentalActAndTCFD]: "U.K. Environmental Act & TCFD",
  [LegalSkill.USSECESGLaws]: "U.S. SEC ESG Laws",
  [LegalSkill.ToxicTort]: "Toxic Tort",
  [LegalSkill.UKTaskForceOnClimateRelatedFinancialDisclosuresTCFD]: "U.K. Task Force on Climate-related Financial Disclosures (TCFD)",
  [LegalSkill.UKTheCompaniesAct2006]: "U.K. The Companies Act 2006",
  [LegalSkill.USADACompliance]: "U.S. ADA Compliance",
  [LegalSkill.USCleanWaterActCWA]: "U.S. Clean Water Act (CWA)",
  [LegalSkill.USResourceConservationAndRecoveryActRCRA]: "U.S. Resource Conservation and Recovery Act (RCRA)",
  [LegalSkill.AsianRegulatoryAdvisory_RegulatoryExpertise_EnvironmentalSocialAndGovernanceCompliance]: "Asian Regulatory Advisory",
  [LegalSkill.AustralianRegulatoryAdvisory_RegulatoryExpertise_EnvironmentalSocialAndGovernanceCompliance]: "Australian Regulatory Advisory",
  [LegalSkill.CanadianRegulatoryAdvisory_RegulatoryExpertise_EnvironmentalSocialAndGovernanceCompliance]: "Canadian Regulatory Advisory",
  [LegalSkill.USWebContentAccessibilityGuidelinesWCAGDigitalAccessibility]: "U.S. Web Content Accessibility Guidelines (WCAG) / Digital Accessibility",
  [LegalSkill.PFAS]: "PFAS Legal Counsel",
  [LegalSkill.USCleanAirActCAA_RegulatoryExpertise_EnvironmentalSocialAndGovernanceCompliance]: "U.S. Clean Air Act (CAA)",
  [LegalSkill.USCERCLASuperfund]: "U.S. CERCLA/Superfund",
  [LegalSkill.USEPCRA]: "U.S. EPCRA",
  [LegalSkill.USFIFRA]: "U.S. FIFRA",
  [LegalSkill.USTSCA]: "U.S. TSCA",
  [LegalSkill.CorporateTax]: "Corporate Tax",
  [LegalSkill.ContractsLicensesAndLeases]: "Contracts, Licenses & Leases",
  [LegalSkill.IPManagement]: "IP Management",
  [LegalSkill.RiskManagement]: "Risk Management",
  [LegalSkill.BoardSupport]: "Board Support",
  [LegalSkill.CorporateGovernance]: "Corporate Governance",
  [LegalSkill.Financing_Activities]: "Financing",
  [LegalSkill.IntellectualProperty]: "Intellectual Property",
  [LegalSkill.LaborAndEmployment]: "Labor & Employment",
  [LegalSkill.MergersAndAcquisitions]: "Mergers & Acquisitions",
  [LegalSkill.ProductAdvice]: "Product Advice",
  [LegalSkill.AILicensingAgreements]: "AI Licensing Agreements",
  [LegalSkill.AIPrivacyAndCybersecurityAssessmentAndPolicies]: "AI Privacy & Cybersecurity Assessment & Policies",
  [LegalSkill.AIProductCounsel]: "AI Product Counsel",
  [LegalSkill.AIRegulatoryCompliance_Activities]: "AI Regulatory Compliance",
  [LegalSkill.AISocialResponsibility_Activities]: "AI Social Responsibility",
  [LegalSkill.AISoftwareProcurement]: "AI Software Procurement",
  [LegalSkill.AIRiskAssessments]: "AI Risk Assessments",
  [LegalSkill.InternalInvestigationsAndRiskAssessments]: "Internal Investigations & Risk Assessments",
  [LegalSkill.RegulatoryInquiryResponse]: "Regulatory Inquiry Response & Government Agency Coordination",
  [LegalSkill.MultiJurisdictionalAndCrossBorderInvestigations]: "Multi-jurisdictional & Cross-border Investigations",
  [LegalSkill.RegulatoryHearingsAndTestimony]: "Regulatory Hearings, Testimony & Subpoena Response",
  [LegalSkill.SettlementNegotiationAndVoluntaryDisclosures]: "Settlement Negotiation & Voluntary Disclosures",
  [LegalSkill.WhistleblowerComplaintsAndSelfReporting]: "Compliance Program Development & Implementation",
  [LegalSkill.RegulatoryExaminationsAndOnsiteVisits]: "Regulatory Examinations & On-site Visits",
  [LegalSkill.HandlingAndManagingEnforcementActions]: "Enforcement Actions Handling & Management",
  [LegalSkill.RegulatoryChangeManagement]: "Regulatory Change Management & Advisory",
  [LegalSkill.AsianBankingAndFinanceLaws]: "Asian Banking & Finance Laws",
  [LegalSkill.AustralianBankingAndFinanceLaws]: "Australian Banking & Finance Laws",
  [LegalSkill.CanadianBankingAndFinanceLaws]: "Canadian Banking & Finance Laws",
  [LegalSkill.ConsumerProtectionRegulatoryCompliance]: "Consumer Protection Regulatory Compliance",
  [LegalSkill.EuropeanBankingAndFinanceLaws]: "European Banking & Finance Laws",
  [LegalSkill.UKBankingAndFinanceLaws]: "U.K. Banking & Finance Laws",
  [LegalSkill.USBankingLaws]: "U.S. Banking Laws",
  [LegalSkill.USKYCAndAML]: "U.S. KYC & AML Compliance",
  [LegalSkill.USSECAndBlueSkyLaws]: "U.S. SEC & Blue Sky Laws",
  [LegalSkill.USFederalBankingRegulators]: "U.S. Federal Banking Regulators (FRB, OCC, FDIC)",
  [LegalSkill.USSecuritiesAndInvestmentRegulation]: "U.S. Securities & Investment Regulation (SEC, FINRA, Blue Sky)",
  [LegalSkill.CommodityFuturesTradingCommission]: "U.S. Commodity Futures Trading Commission (CFTC) & Derivatives",
  [LegalSkill.ConsumerFinancialProtectionBureau]: "U.S. Consumer Financial Protection Bureau (CFPB)",
  [LegalSkill.ECCNClassification]: "ECCN Classification",
  [LegalSkill.VoluntaryDisclosuresDrafting]: "Voluntary Disclosures Drafting",
  [LegalSkill.ExportLicenseApplicationPreparation]: "Export License Application Preparation",
  [LegalSkill.MAndATradeAndExportDueDiligence]: "M&A Trade & Export Due Diligence",
  [LegalSkill.InternalInvestigations_Activities_TradeComplianceSanctionsAndExportControls]: "Internal Investigations",
  [LegalSkill.ComplianceProgramManagement]: "Compliance Program Management",
  [LegalSkill.TradeCompliancePoliciesAndProceduresCreation]: "Trade Compliance Policies & Procedures Creation",
  [LegalSkill.ExportControlPoliciesAndProceduresCreation]: "Export Control Policies & Procedures Creation",
  [LegalSkill.HarmonizedTariffCodeHTCHTSClassification]: "Harmonized Tariff Code (HTC) / Harmonized Tariff Schdule (HTS) Classification",
  [LegalSkill.SanctionsOFACScreening]: "Sanctions (OFAC) Screening",
  [LegalSkill.ExportControls_RegulatoryExpertise]: "Export Controls",
  [LegalSkill.TradeCompliance]: "Trade Compliance",
  [LegalSkill.Sanctions_RegulatoryExpertise]: "Sanctions",
  [LegalSkill.USExportAdministrationRegulationsEAR]: "Exports: U.S. Export Administration Regulations (EAR)",
  [LegalSkill.USInternationalTrafficInArmsRegulationsITAR]: "Exports: U.S. International Traffic in Arms Regulations (ITAR)",
  [LegalSkill.CustomsValuationAndTariffClassifications]: "Imports: Customs Valuation & Tariff Classifications",
  [LegalSkill.LicensedCustomsBroker]: "Imports: Licensed Customs Broker",
  [LegalSkill.USAntiDumpingCounterveilingDuties]: "Imports: U.S Anti-Dumping & Counterveiling Duties",
  [LegalSkill.AsianRegulatoryAdvisory_RegulatoryExpertise_InternationalTradeAndSanctionsInvestmentComplianceAndMarketAccess]: "International Trade Compliance: Asian Regulatory Advisory",
  [LegalSkill.AustralianRegulatoryAdvisory_RegulatoryExpertise_InternationalTradeAndSanctionsInvestmentComplianceAndMarketAccess]: "International Trade Compliance: Australian Regulatory Advisory",
  [LegalSkill.EuropeanRegulatoryAdvisory_RegulatoryExpertise_InternationalTradeAndSanctionsInvestmentComplianceAndMarketAccess]: "International Trade Compliance: European Regulatory Advisory",
  [LegalSkill.Incoterms]: "International Trade Compliance: International Commercial Terms (Incoterms)",
  [LegalSkill.KYCAndPoliticallyExposedPersonsPEPs]: "International Trade Compliance: KYC & Politically Exposed Persons (PEPs)",
  [LegalSkill.LatinAmericanRegulatoryAdvisory]: "International Trade Compliance: Latin American Regulatory Advisory",
  [LegalSkill.UKRegulatoryAdvisory_RegulatoryExpertise_InternationalTradeAndSanctionsInvestmentComplianceAndMarketAccess]: "International Trade Compliance: U.K. Regulatory Advisory",
  [LegalSkill.USForeignCorruptPracticesActFCPA_RegulatoryExpertise]: "International Trade Compliance: U.S. Foreign Corrupt Practices Act (FCPA)",
  [LegalSkill.USForeignDirectProductRule]: "International Trade Compliance: U.S. Foreign Direct Product Rule",
  [LegalSkill.USSuspiciousActivityReportingSAR]: "International Trade Compliance: U.S. Suspicious Activity Reporting (SAR)",
  [LegalSkill.WorldTradeOrganizationCompliance]: "International Trade Compliance: World Trade Organization Compliance (WTO)",
  [LegalSkill.OfficeOfForeignAssetsControlOFAC]: "Sanctions: Office of Foreign Assets Control (OFAC)",
  [LegalSkill.RiskAssessmentsAndInternalAudits_Activities]: "Risk Assessments & Internal Audits",
  [LegalSkill.ProcurementControls]: "Procurement Controls",
  [LegalSkill.ComplianceProgramDevelopmentAndImplementation]: "Compliance Program Development & Implementation",
  [LegalSkill.US340BEligibilityAndCompliance]: "U.S. 340B Eligibility & Compliance",
  [LegalSkill.US501C3EligibilityAndCompliance]: "U.S. 501c3 Eligibility & Compliance",
  [LegalSkill.USAffordableCareActACA]: "U.S. Affordable Care Act (ACA)",
  [LegalSkill.USAntiKickbackStatute]: "U.S. Anti-Kickback Statute",
  [LegalSkill.MedicalAffairsAndPatientEngagmeent]: "Medical Affairs & Patient Engagement",
  [LegalSkill.RFPs]: "Healthcare RFP Legal Counsel",
  [LegalSkill.USHealthInsurancePortabilityAndAccountabilityActHIPAA]: "U.S. Health Insurance Portability and Accountability Act (HIPAA)",
  [LegalSkill.USMedicareAndMedicaid]: "U.S. Medicare & Medicaid",
  [LegalSkill.USStarkLaw]: "U.S. Stark Law",
  [LegalSkill.AsianRegulatoryAdvisory_RegulatoryExpertise_HealthcareAndLifeSciencesRegulationAndCompliance]: "Asian Regulatory Advisory",
  [LegalSkill.AustralianRegulatoryAdvisory_RegulatoryExpertise_HealthcareAndLifeSciencesRegulationAndCompliance]: "Australian Regulatory Advisory",
  [LegalSkill.CanadianRegulatoryAdvisory_RegulatoryExpertise_HealthcareAndLifeSciencesRegulationAndCompliance]: "Canadian Regulatory Advisory",
  [LegalSkill.EuropeanRegulatoryAdvisory_RegulatoryExpertise_HealthcareAndLifeSciencesRegulationAndCompliance]: "European Regulatory Advisory",
  [LegalSkill.UKRegulatoryAdvisory_RegulatoryExpertise_HealthcareAndLifeSciencesRegulationAndCompliance]: "U.K. Regulatory Advisory",
  [LegalSkill.EUEMAApproval]: "EU - EMA Approval",
  [LegalSkill.US510KDisclosures]: "U.S. 510k Disclosures",
  [LegalSkill.USFDARegistrationAndListingTitle21CFRPart807]: "U.S. FDA Registration & Listing (Title 21 CFR Part 807)",
  [LegalSkill.USPremarketApproval21CFRPart814]: "U.S. Premarket Approval (21 CFR Part 814)",
  [LegalSkill.USGoodPracticeGuidelinesGxPGMPGLPGCP]: "U.S. Good Practice Guidelines (GxP, GMP, GLP, GCP)",
  [LegalSkill.ProductApplicationReviewActivities]: "Product Application Review Activities",
  [LegalSkill.ClinicalTrialRegulatorySubmissions]: "Clinical Trial Regulatory Submissions",
  [LegalSkill.ISORegulationAndCompliance_Expertise]: "ISO Regulation & Compliance",
  [LegalSkill.PharmacovigilanceAndPostMarketSurveillance]: "Pharmacovigilance & Post-Market Surveillance",
  [LegalSkill.QualityManagementSystemQMSCompliance]: "Quality Management System (QMS) Compliance",
  [LegalSkill.AsianRegulatoryAdvisory_Expertise_LifeSciencesRegulatory]: "Asian Regulatory Advisory",
  [LegalSkill.AustralianRegulatoryAdvisory_Expertise_LifeSciencesRegulatory]: "Australian Regulatory Advisory",
  [LegalSkill.CanadianRegulatoryAdvisory_Expertise_LifeSciencesRegulatory]: "Canadian Regulatory Advisory",
  [LegalSkill.EuropeanRegulatoryAdvisory_Expertise_LifeSciencesRegulatory]: "European Regulatory Advisory",
  [LegalSkill.UKRegulatoryAdvisory_Expertise_LifeSciencesRegulatory]: "U.K. Regulatory Advisory",
  [LegalSkill.ComplianceProgramDevelopment_Activities_LifeSciencesCompliance]: "Compliance Program Development",
  [LegalSkill.Investigations_Activities_LifeSciencesCompliance]: "Investigations",
  [LegalSkill.RiskAssessmentsAndInternalAudits_Activities_LifeSciencesCompliance]: "Risk Assessments & Internal Audits",
  [LegalSkill.CompliancePolicyDevelopment_Activities_LifeSciencesCompliance]: "Compliance Policy Development",
  [LegalSkill.PayorAgreements]: "Payor Agreements",
  [LegalSkill.ManagedCareContracts]: "Managed Care Contracts",
  [LegalSkill.ConsultingPartnershipsAndJointVentures]: "Consulting Partnerships & Joint Ventures",
  [LegalSkill.PharmacyBenefitManagementPBM]: "Pharmacy Benefit Management (PBM)",
  [LegalSkill.ProductPricingAndReimbursement]: "Product Pricing & Reimbursement",
  [LegalSkill.HEORHealthEconomicsAndOutcomes]: "HEOR (Health Economics & Outcomes Research)",
  [LegalSkill.FormularyStrategyAndPAndTCommitteeNavigation]: "Formulary Strategy & P&T Committee Navigation",
  [LegalSkill.ValueBasedCareArrangements]: "Value-Based Care Arrangements",
  [LegalSkill.PriorAuthorizationAndUtilizationManagement]: "Prior Authorization & Utilization Management",
  [LegalSkill.SupplyChainAndDistributionAgreements]: "Supply Chain & Distribution Agreements",
  [LegalSkill.CMOContractManufacturingOrganizationAgreements]: "CMO (Contract Manufacturing Organization) Agreements",
  [LegalSkill.QualityAgreements]: "Quality Agreements",
  [LegalSkill.VendorAndConfidentialityAgreements]: "Vendor & Confidentiality Agreements",
  [LegalSkill.DevelopmentAndLicensingAgreements]: "Development & Licensing Agreements",
  [LegalSkill.TechnologyTransferAgreements_Expertise_LifeSciencesSupplyChain]: "Technology Transfer Agreements",
  [LegalSkill.ManufacturingRegulatoryCompliance]: "Manufacturing Regulatory Compliance",
  [LegalSkill.ProductRecallsAndSupplyChainManagement]: "Product Recalls & Supply Chain Risk Management",
  [LegalSkill.TechnologyTransferAgreements_AgreementTypes_ClinicalTrials]: "Technology Transfer Agreements",
  [LegalSkill.DataUseAgreements_AgreementTypes_ClinicalTrials]: "Data Use Agreements",
  [LegalSkill.InboundAndOutboundLicensingAgreements_AgreementTypes_ClinicalTrials]: "Inbound & Outbound Licensing Agreements",
  [LegalSkill.HCPInteractions]: "HCP Interactions",
  [LegalSkill.ResearchSponsorshipsAndGrants]: "Research Sponsorship & Grants",
  [LegalSkill.InformedConsentAndPatientPrivacy]: "Informed Consent & Patient Privacy",
  [LegalSkill.FDAAndEMARegulatoryStrategy]: "FDA & EMA Regulatory Strategy",
  [LegalSkill.ClinicalRegulatoryCompliance]: "Clinical Regulatory Compliance",
  [LegalSkill.ClinicalDataManagementAndProtection]: "Clinical Data Management & Protection",
  [LegalSkill.ClinicalResearchOrgAgreementsCRO]: "CRO (Clinical Research Organization) Agreements",
  [LegalSkill.ClinicalTrialAgreementsCTA]: "Clinical Trial Agreements (CTA)",
  [LegalSkill.ClinicalTrialAgreementPolicyAndProcedures]: "Clinical Trial Agreement Policy & Procedure Development",
  [LegalSkill.ClinicalTrialPrivacyAdviceAndCounsel]: "Clinical Trial Privacy Advice and Counsel",
  [LegalSkill.GeneralAndRegulatoryAdvisory]: "General & Regulatory Advisory",
  [LegalSkill.InvestigatorInitiatedTrialsAndCollaborativeAgreements]: "Investigator-Initiated Trial Agreements",
  [LegalSkill.MaterialTransferAgreementMTA]: "Material Transfer Agreement (MTA)",
  [LegalSkill.PreClinicalAndNonClinicalTrialAgreements]: "Pre-Clinical & Non-Clinical Trial Agreements",
  [LegalSkill.AIMachineLearningDataLearning_Activities_IPLicensing]: "AI, Machine-Learning, Data-Learning Advice and Counsel",
  [LegalSkill.InboundLicensingAgreements_Activities_IPLicensing]: "Inbound Licensing Agreements",
  [LegalSkill.LicensingDueDiligence_Activities_IPLicensing]: "Licensing Due Diligence",
  [LegalSkill.OutboundLicensingAgreements_Activities_IPLicensing]: "Outbound Licensing Agreements",
  [LegalSkill.Copyright_IPType_Activities_IPLicensing]: "Copyright",
  [LegalSkill.OpenSourceSEPFRANDSoftware_IPType_IPLicensing]: "Open-Source, SEP, FRAND Software",
  [LegalSkill.OtherIP_IPType_IPLicensing]: "Other IP",
  [LegalSkill.Patent_IPType_IPLicensing]: "Patent",
  [LegalSkill.Software_IPType_IPLicensing]: "Software",
  [LegalSkill.Trademark_IPType_IPLicensing]: "Trademark",
  [LegalSkill.FiftyStateSurveys_Activities_InvestigationsAndEnforcement]: "50 State Surveys",
  [LegalSkill.AgencyInteractionAndCommunication_Activities_InvestigationsAndEnforcement]: "Agency Interaction & Communication ",
  [LegalSkill.ComplianceAuditsAndRiskAssessments_Activities_InvestigationsAndEnforcement]: "Compliance Audits & Risk Assessments",
  [LegalSkill.ComplianceProgramsPoliciesAndTrainings_Activities_InvestigationsAndEnforcement]: "Compliance Programs, Policies & Trainings",
  [LegalSkill.DocumentAndEvidenceManagement_Activities_InvestigationsAndEnforcement]: "Document & Evidence Management ",
  [LegalSkill.GovernmentAgencyResponseAndCompliance_Activities_InvestigationsAndEnforcement]: "Government Agency Response & Compliance",
  [LegalSkill.GovernmentRegulation_Interpretation_Activities_InvestigationsAndEnforcement]: "Government Regulation Interpretation",
  [LegalSkill.InvestigationManagementAndStrategy_Activities_InvestigationsAndEnforcement]: "Investigation Management & Strategy ",
  [LegalSkill.RegulatoryChangeManagementAndAdvisory_Activities_InvestigationsAndEnforcement]: "Regulatory Change Management & Advisory",
  [LegalSkill.RiskAssessmentAndMitigation_Activities_InvestigationsAndEnforcement]: "Risk Assessment & Mitigation ",
  [LegalSkill.WitnessAndInterviewManagement_Activities_InvestigationsAndEnforcement]: "Witness & Interview Management",
};
